export const HCP_MODEL_SEED = [
  { name: "mdm_id", displayName: "mdm_id", description: "Represents the MDM Id", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "onekey_individual_id", displayName: "onekey_individual_id", description: "Represents the Onekey Individual Id", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "source", displayName: "source", description: "Represents the Source", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "first_name", displayName: "first_name", description: "Represents the First Name", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "middle_name", displayName: "middle_name", description: "Represents the Middle Name", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "last_name", displayName: "last_name", description: "Represents the Last Name", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "suffix", displayName: "suffix", description: "Represents the Suffix", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "gender", displayName: "gender", description: "Represents the Gender", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "birth_year", displayName: "birth_year", description: "Represents the Birth Year", dataType: "int", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "address_line_1", displayName: "address_line_1", description: "Represents the Address Line 1", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "address_line_2", displayName: "address_line_2", description: "Represents the Address Line 2", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "city", displayName: "city", description: "Represents the City", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "state", displayName: "state", description: "Represents the State", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "zip", displayName: "zip", description: "Represents the Zip", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "primary_profession", displayName: "primary_profession", description: "Represents the Primary Profession", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "primary_specialty", displayName: "primary_specialty", description: "Represents the Primary Specialty", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "full_profile", displayName: "full_profile", description: "Represents the Full Profile", dataType: "Boolean", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "npi_id", displayName: "npi_id", description: "Represents the NPI Id", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "status", displayName: "status", description: "Represents the Status", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "created_date", displayName: "created_date", description: "Represents the Created Date", dataType: "Date", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "updated_date", displayName: "updated_date", description: "Represents the Updated Date", dataType: "Date", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "mdm_created_time", displayName: "mdm_created_time", description: "Represents the MDM Created Time", dataType: "Date", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "mdm_updated_time", displayName: "mdm_updated_time", description: "Represents the MDM Updated Time", dataType: "Date", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "ama_pdrp", displayName: "ama_pdrp", description: "Represents the AMA PDRP", dataType: "Boolean", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "is_eligible", displayName: "is_eligible", description: "Represents the Is Eligible", dataType: "Boolean", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "ama_do_not_call", displayName: "ama_do_not_call", description: "Represents the AMA Do Not Call", dataType: "Boolean", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "pmc_cust_id", displayName: "pmc_cust_id", description: "Represents the PMC Cust Id", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
];

export const HCP_VALIDATION_SEED = [
  { name: "NPI Id", validationLevel: "error", lastModifiedDate: "18/04/2025", type: "regex", active: true, rule: "^d{10}$", description: "NPI must be a 10-digit number with only numeric characters." },
  { name: "Last Name", validationLevel: "error", lastModifiedDate: "19/04/2025", type: "Exist", active: true, rule: "", description: "Last Name is required and cannot be empty." },
  { name: "Phone Number", validationLevel: "warning", lastModifiedDate: "18/04/2025", type: "regex", active: true, rule: "^[ds-+()]+$", description: "Phone Number must not contain alphabets or special characters other than digits, spaces, dashes, plus signs, and parentheses." },
  { name: "IMS Id", validationLevel: "warning", lastModifiedDate: "20/04/2025", type: "regex", active: true, rule: "^\\d+$", description: "IMS Id must contain only numeric characters." },
];

export const HCP_CLEANSER_SEED = [
  { displayName: "Fullname Cleanser", attribute: "Full Name", cleanserType: "Out of the box Cleanser", cleanser: "Fullname Cleanser", lastModifiedDate: "18/04/2025", active: true },
  { displayName: "Address Cleanser", attribute: "Address", cleanserType: "Out of the box Cleanser", cleanser: "Address Cleanser", lastModifiedDate: "19/04/2025", active: true },
];

export const HCP_RDM_SEED = [
  {
    name: "Active Status",
    startdate: "2023-01-01",
    enddate: "2023-12-31",
    sourcevalues: 2,
    unmappedvalues: 1,
    tableData: [
      {
        "Canonical Value": {
          code: "A",
          description: "Active",
        },

        Onekey: {
          code: "A",
          description: "Active",
        },
        XPT: {
          code: "A",
          description: "Active",
        },
        ConcertAI: {
          code: "A",
          description: "Active",
        },
        MDM: {
          code: "A",
          description: "Active",
        },
      },
      {
        "Canonical Value": {
          code: "I",
          description: "Inactive",
        },
        Onekey: {
          code: "I",
          description: "Inactive",
        },
        XPT: {
          code: "I",
          description: "Inactive",
        },
        ConcertAI: {
          code: "I",
          description: "Inactive",
        },
        MDM: {
          code: "I",
          description: "Inactive",
        },
      },
    ],
  },
  {
    name: "Specialty",
    startdate: "2022-03-01",
    enddate: "2022-03-10",
    sourcevalues: 50,
    unmappedvalues: 2,
    tableData: [
      {
        "Canonical Value": {
          code: "D",
          description: "DERMATOLOGY",
        },

        Onekey: {
          code: "D",
          description: "DERM",
        },
        XPT: {
          code: "DERM",
          description: "D",
        },
        ConcertAI: {
          code: "D",
          description: "DERMATOLOGY",
        },
        MDM: {
          code: "D",
          description: "DERMATOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "RN",
          description: "REGISTERED NURSE",
        },

        Onekey: {
          code: "RN",
          description: "REGISTERED NURSE",
        },
        XPT: {
          code: "RN",
          description: "REGISTERED NURSE",
        },
        ConcertAI: {
          code: "RN",
          description: "REGISTERED NURSE",
        },
        MDM: {
          code: "RN",
          description: "REGISTERED NURSE",
        },
      },
      {
        "Canonical Value": {
          code: "MEST",
          description: "MEDICAL ESTHETICIAN",
        },

        Onekey: { code: "MEST", description: "MEDICAL ESTHETICIAN" },
        XPT: { code: "MEST", description: "MEDICAL ESTHETICIAN" },
        ConcertAI: { code: "MEST", description: "MEDICAL ESTHETICIAN" },
        MDM: { code: "MEST", description: "MEDICAL ESTHETICIAN" },
      },
      {
        "Canonical Value": {
          code: "PDA",
          description: "PEDIATRIC ALLERGY",
        },

        Onekey: { code: "PDA", description: "PEDIATRIC ALLERGY" },
        XPT: { code: "PDA", description: "PEDIATRIC ALLERGY" },
        ConcertAI: { code: "PDA", description: "PEDIATRIC ALLERGY" },
        MDM: { code: "PDA", description: "PEDIATRIC ALLERGY" },
      },
      {
        "Canonical Value": {
          code: "OAR",
          description: "ADULT RECONSTRUCTIVE ORTHOPEDICS",
        },

        Onekey: {
          code: "OAR",
          description: "ADULT RECONSTRUCTIVE ORTHOPEDICS",
        },
        XPT: {
          code: "OAR",
          description: "ADULT RECONSTRUCTIVE ORTHOPEDICS",
        },
        ConcertAI: {
          code: "OAR",
          description: "ADULT RECONSTRUCTIVE ORTHOPEDICS",
        },
        MDM: {
          code: "OAR",
          description: "ADULT RECONSTRUCTIVE ORTHOPEDICS",
        },
      },
      {
        "Canonical Value": {
          code: "CN",
          description: "CLINICAL NEUROPHYSIOLOGY",
        },

        Onekey: { code: "CN", description: "CLINICAL NEUROPHYSIOLOGY" },
        XPT: { code: "CN", description: "CLINICAL NEUROPHYSIOLOGY" },
        ConcertAI: {
          code: "CN",
          description: "CLINICAL NEUROPHYSIOLOGY",
        },
        MDM: { code: "CN", description: "CLINICAL NEUROPHYSIOLOGY" },
      },
      {
        "Canonical Value": { code: "PSY", description: "PSYCHOLOGY" },

        Onekey: { code: "PSY", description: "PSYCHOLOGY" },
        XPT: { code: "PSY", description: "PSYCHOLOGY" },
        ConcertAI: { code: "PSY", description: "PSYCHOLOGY" },
        MDM: { code: "PSY", description: "PSYCHOLOGY" },
      },
      {
        "Canonical Value": {
          code: "CCP",
          description: "PEDIATRIC CRITICAL CARE MEDICINE",
        },

        Onekey: {
          code: "CCP",
          description: "PEDIATRIC CRITICAL CARE MEDICINE",
        },
        XPT: {
          code: "CCP",
          description: "PEDIATRIC CRITICAL CARE MEDICINE",
        },
        ConcertAI: {
          code: "CCP",
          description: "PEDIATRIC CRITICAL CARE MEDICINE",
        },
        MDM: {
          code: "CCP",
          description: "PEDIATRIC CRITICAL CARE MEDICINE",
        },
      },
      {
        "Canonical Value": {
          code: "PHO",
          description: "PEDIATRIC HEMATOLOGY/ONCOLOGY",
        },

        Onekey: {
          code: "PHO",
          description: "PEDIATRIC HEMATOLOGY/ONCOLOGY",
        },
        XPT: {
          code: "PHO",
          description: "PEDIATRIC HEMATOLOGY/ONCOLOGY",
        },
        ConcertAI: {
          code: "PHO",
          description: "PEDIATRIC HEMATOLOGY/ONCOLOGY",
        },
        MDM: {
          code: "PHO",
          description: "PEDIATRIC HEMATOLOGY/ONCOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "PHP",
          description: "PUBLIC HEALTH & GENERAL PREVENTIVE MED",
        },

        Onekey: {
          code: "PHP",
          description: "PUBLIC HEALTH & GENERAL PREVENTIVE MED",
        },
        XPT: {
          code: "PHP",
          description: "PUBLIC HEALTH & GENERAL PREVENTIVE MED",
        },
        ConcertAI: {
          code: "PHP",
          description: "PUBLIC HEALTH & GENERAL PREVENTIVE MED",
        },
        MDM: {
          code: "PHP",
          description: "PUBLIC HEALTH & GENERAL PREVENTIVE MED",
        },
      },
      {
        "Canonical Value": {
          code: "IFP",
          description: "INTERNAL MEDICINE/FAMILY MEDICINE",
        },

        Onekey: {
          code: "IFP",
          description: "INTERNAL MEDICINE/FAMILY MEDICINE",
        },
        XPT: {
          code: "IFP",
          description: "INTERNAL MEDICINE/FAMILY MEDICINE",
        },
        ConcertAI: {
          code: "IFP",
          description: "INTERNAL MEDICINE/FAMILY MEDICINE",
        },
        MDM: {
          code: "IFP",
          description: "INTERNAL MEDICINE/FAMILY MEDICINE",
        },
      },

      {
        "Canonical Value": {
          code: "CNS",
          description: "CLINICAL NURSE SPECIALIST",
        },

        Onekey: { code: "CNS", description: "CLINICAL NURSE SPECIALIST" },
        XPT: { code: "CNS", description: "CLINICAL NURSE SPECIALIST" },
        ConcertAI: {
          code: "CNS",
          description: "CLINICAL NURSE SPECIALIST",
        },
        MDM: { code: "CNS", description: "CLINICAL NURSE SPECIALIST" },
      },
      {
        "Canonical Value": { code: "228", description: "Central Fill" },

        Onekey: { code: "228", description: "Central Fill" },
        XPT: { code: "228", description: "Central Fill" },
        ConcertAI: { code: "228", description: "Central Fill" },
        MDM: { code: "228", description: "Central Fill" },
      },
      {
        "Canonical Value": {
          code: "PDT",
          description: "MEDICAL TOXICOLOGY (PEDIATRICS)",
        },

        Onekey: {
          code: "PDT",
          description: "MEDICAL TOXICOLOGY (PEDIATRICS)",
        },
        XPT: {
          code: "PDT",
          description: "MEDICAL TOXICOLOGY (PEDIATRICS)",
        },
        ConcertAI: {
          code: "PDT",
          description: "MEDICAL TOXICOLOGY (PEDIATRICS)",
        },
        MDM: {
          code: "PDT",
          description: "MEDICAL TOXICOLOGY (PEDIATRICS)",
        },
      },
      {
        "Canonical Value": {
          code: "TR",
          description: "THERAPEUTIC RADIOLOGY",
        },

        Onekey: { code: "TR", description: "THERAPEUTIC RADIOLOGY" },
        XPT: { code: "TR", description: "THERAPEUTIC RADIOLOGY" },
        ConcertAI: { code: "TR", description: "THERAPEUTIC RADIOLOGY" },
        MDM: { code: "TR", description: "THERAPEUTIC RADIOLOGY" },
      },
      {
        "Canonical Value": {
          code: "PRA",
          description: "PEDIATRIC RHEUMATOLOGY",
        },

        Onekey: {
          code: "ESM",
          description: "SPORTS MEDICINE (EMERGENCY MEDICINE)",
        },
        XPT: {
          code: "ESM",
          description: "SPORTS MEDICINE (EMERGENCY MEDICINE)",
        },
        ConcertAI: {
          code: "ESM",
          description: "SPORTS MEDICINE (EMERGENCY MEDICINE)",
        },
        MDM: {
          code: "ESM",
          description: "SPORTS MEDICINE (EMERGENCY MEDICINE)",
        },
      },
      {
        "Canonical Value": {
          code: "ICE",
          description: "CLINICAL CARDIAC ELECTROPHYSIOLOGY",
        },

        Onekey: {
          code: "ICE",
          description: "CLINICAL CARDIAC ELECTROPHYSIOLOGY",
        },
        XPT: {
          code: "ICE",
          description: "CLINICAL CARDIAC ELECTROPHYSIOLOGY",
        },
        ConcertAI: {
          code: "ICE",
          description: "CLINICAL CARDIAC ELECTROPHYSIOLOGY",
        },
        MDM: {
          code: "ICE",
          description: "CLINICAL CARDIAC ELECTROPHYSIOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "PG",
          description: "PEDIATRIC GASTROENTEROLOGY",
        },

        Onekey: { code: "PG", description: "PEDIATRIC GASTROENTEROLOGY" },
        XPT: { code: "PG", description: "PEDIATRIC GASTROENTEROLOGY" },
        ConcertAI: {
          code: "PG",
          description: "PEDIATRIC GASTROENTEROLOGY",
        },
        MDM: { code: "PG", description: "PEDIATRIC GASTROENTEROLOGY" },
      },
      {
        "Canonical Value": {
          code: "ALTH",
          description: "ALTERNATE THERAPY",
        },

        Onekey: { code: "ALTH", description: "ALTERNATE THERAPY" },
        XPT: { code: "ALTH", description: "ALTERNATE THERAPY" },
        ConcertAI: { code: "ALTH", description: "ALTERNATE THERAPY" },
        MDM: { code: "ALTH", description: "ALTERNATE THERAPY" },
      },
      {
        "Canonical Value": {
          code: "222",
          description: "Physician Buying Organization",
        },

        Onekey: {
          code: "222",
          description: "Physician Buying Organization",
        },
        XPT: {
          code: "222",
          description: "Physician Buying Organization",
        },
        ConcertAI: {
          code: "222",
          description: "Physician Buying Organization",
        },
        MDM: {
          code: "222",
          description: "Physician Buying Organization",
        },
      },
      {
        "Canonical Value": {
          code: "SPS",
          description: "Surgery/Plastic Surgery",
        },

        Onekey: { code: "SPS", description: "Surgery/Plastic Surgery" },
        XPT: { code: "SPS", description: "Surgery/Plastic Surgery" },
        ConcertAI: {
          code: "SPS",
          description: "Surgery/Plastic Surgery",
        },
        MDM: { code: "SPS", description: "Surgery/Plastic Surgery" },
      },
      {
        "Canonical Value": {
          code: "AS",
          description: "ABDOMINAL SURGERY",
        },

        Onekey: { code: "AS", description: "ABDOMINAL SURGERY" },
        XPT: { code: "AS", description: "ABDOMINAL SURGERY" },
        ConcertAI: { code: "AS", description: "ABDOMINAL SURGERY" },
        MDM: { code: "AS", description: "ABDOMINAL SURGERY" },
      },
      {
        "Canonical Value": {
          code: "ORS",
          description: "ORTHOPEDIC SURGERY",
        },

        Onekey: { code: "ORS", description: "ORTHOPEDIC SURGERY" },
        XPT: { code: "ORS", description: "ORTHOPEDIC SURGERY" },
        ConcertAI: { code: "ORS", description: "ORTHOPEDIC SURGERY" },
        MDM: { code: "ORS", description: "ORTHOPEDIC SURGERY" },
      },
      {
        "Canonical Value": {
          code: "253",
          description: "Healthcare Organization",
        },

        Onekey: { code: "253", description: "Healthcare Organization" },
        XPT: { code: "253", description: "Healthcare Organization" },
        ConcertAI: {
          code: "253",
          description: "Healthcare Organization",
        },
        MDM: { code: "253", description: "Healthcare Organization" },
      },
      {
        "Canonical Value": { code: "158", description: "CAT Scan" },

        Onekey: { code: "158", description: "CAT Scan" },
        XPT: { code: "158", description: "CAT Scan" },
        ConcertAI: { code: "158", description: "CAT Scan" },
        MDM: { code: "158", description: "CAT Scan" },
      },
      {
        "Canonical Value": {
          code: "ACA",
          description: "ADULT CARDIOTHORACIC ANESTHESIOLOGY",
        },

        Onekey: {
          code: "ACA",
          description: "ADULT CARDIOTHORACIC ANESTHESIOLOGY",
        },
        XPT: {
          code: "ACA",
          description: "ADULT CARDIOTHORACIC ANESTHESIOLOGY",
        },
        ConcertAI: {
          code: "ACA",
          description: "ADULT CARDIOTHORACIC ANESTHESIOLOGY",
        },
        MDM: {
          code: "ACA",
          description: "ADULT CARDIOTHORACIC ANESTHESIOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "CPP",
          description: "PED/PSYCH/CHILD & ADOLESCENT PSYCH",
        },

        Onekey: {
          code: "CPP",
          description: "PED/PSYCH/CHILD & ADOLESCENT PSYCH",
        },
        XPT: {
          code: "CPP",
          description: "PED/PSYCH/CHILD & ADOLESCENT PSYCH",
        },
        ConcertAI: {
          code: "CPP",
          description: "PED/PSYCH/CHILD & ADOLESCENT PSYCH",
        },
        MDM: {
          code: "CPP",
          description: "PED/PSYCH/CHILD & ADOLESCENT PSYCH",
        },
      },
      {
        "Canonical Value": {
          code: "HPE",
          description: "HOSPICE & PALLIATIVE MED (EMERGENCY MED)",
        },

        Onekey: {
          code: "HPE",
          description: "HOSPICE & PALLIATIVE MED (EMERGENCY MED)",
        },
        XPT: {
          code: "HPE",
          description: "HOSPICE & PALLIATIVE MED (EMERGENCY MED)",
        },
        ConcertAI: {
          code: "HPE",
          description: "HOSPICE & PALLIATIVE MED (EMERGENCY MED)",
        },
        MDM: {
          code: "HPE",
          description: "HOSPICE & PALLIATIVE MED (EMERGENCY MED)",
        },
      },
      {
        "Canonical Value": {
          code: "PPR",
          description: "PEDIATRIC RHEUMATOLOGY",
        },

        Onekey: {
          code: "PPR",
          description: "PEDIATRIC RHEUMATOLOGY",
        },
        XPT: {
          code: "PPR",
          description: "PEDIATRIC RHEUMATOLOGY",
        },
        ConcertAI: {
          code: "PPR",
          description: "PEDIATRIC RHEUMATOLOGY",
        },
        MDM: {
          code: "PPR",
          description: "PEDIATRIC RHEUMATOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "FPS",
          description: "FACIAL PLASTIC SURGERY",
        },

        Onekey: {
          code: "FPS",
          description: "FACIAL PLASTIC SURGERY",
        },
        XPT: {
          code: "FPS",
          description: "FACIAL PLASTIC SURGERY",
        },
        ConcertAI: {
          code: "FPS",
          description: "FACIAL PLASTIC SURGERY",
        },
        MDM: {
          code: "FPS",
          description: "FACIAL PLASTIC SURGERY",
        },
      },
      {
        "Canonical Value": {
          code: "SRGA",
          description: "SURGICAL ASSISTANT",
        },

        Onekey: {
          code: "SRGA",
          description: "SURGICAL ASSISTANT",
        },
        XPT: {
          code: "SRGA",
          description: "SURGICAL ASSISTANT",
        },
        ConcertAI: {
          code: "SRGA",
          description: "SURGICAL ASSISTANT",
        },
        MDM: {
          code: "SRGA",
          description: "SURGICAL ASSISTANT",
        },
      },
      {
        "Canonical Value": {
          code: "CCE",
          description: "CRITICAL CARE MEDICINE (EM)",
        },

        Onekey: {
          code: "CCE",
          description: "CRITICAL CARE MEDICINE (EM)",
        },
        XPT: {
          code: "CCE",
          description: "CRITICAL CARE MEDICINE (EM)",
        },
        ConcertAI: {
          code: "CCE",
          description: "CRITICAL CARE MEDICINE (EM)",
        },
        MDM: {
          code: "CCE",
          description: "CRITICAL CARE MEDICINE (EM)",
        },
      },
      {
        "Canonical Value": { code: "226", description: "Union Shop" },

        Onekey: {
          code: "226",
          description: "Union Shop",
        },
        XPT: {
          code: "226",
          description: "Union Shop",
        },
        ConcertAI: {
          code: "226",
          description: "Union Shop",
        },
        MDM: {
          code: "226",
          description: "Union Shop",
        },
      },
      {
        "Canonical Value": { code: "256", description: "Federal" },

        Onekey: {
          code: "256",
          description: "Federal",
        },
        XPT: {
          code: "256",
          description: "Federal",
        },
        ConcertAI: {
          code: "256",
          description: "Federal",
        },
        MDM: {
          code: "256",
          description: "Federal",
        },
      },
      {
        "Canonical Value": {
          code: "NRCC",
          description: "NEUROCRITICAL CARE (PSYCH & NEURO)",
        },

        Onekey: {
          code: "NRCC",
          description: "NEUROCRITICAL CARE (PSYCH & NEURO)",
        },
        XPT: {
          code: "NRCC",
          description: "NEUROCRITICAL CARE (PSYCH & NEURO)",
        },
        ConcertAI: {
          code: "NRCC",
          description: "NEUROCRITICAL CARE (PSYCH & NEURO)",
        },
        MDM: {
          code: "NRCC",
          description: "NEUROCRITICAL CARE (PSYCH & NEURO)",
        },
      },
      {
        "Canonical Value": { code: "CNM", description: "NURSE MIDWIFE" },

        Onekey: {
          code: "CNM",
          description: "NURSE MIDWIFE",
        },
        XPT: {
          code: "CNM",
          description: "NURSE MIDWIFE",
        },
        ConcertAI: {
          code: "CNM",
          description: "NURSE MIDWIFE",
        },
        MDM: {
          code: "CNM",
          description: "NURSE MIDWIFE",
        },
      },
      {
        "Canonical Value": {
          code: "PSM",
          description: "SPORTS MEDICINE (PEDIATRICS)",
        },

        Onekey: {
          code: "PSM",
          description: "SPORTS MEDICINE (PEDIATRICS)",
        },
        XPT: {
          code: "PSM",
          description: "SPORTS MEDICINE (PEDIATRICS)",
        },
        ConcertAI: {
          code: "PSM",
          description: "SPORTS MEDICINE (PEDIATRICS)",
        },
        MDM: {
          code: "PSM",
          description: "SPORTS MEDICINE (PEDIATRICS)",
        },
      },
      {
        "Canonical Value": {
          code: "AI",
          description: "ALLERGY & IMMUNOLOGY",
        },

        Onekey: {
          code: "AI",
          description: "ALLERGY & IMMUNOLOGY",
        },
        XPT: {
          code: "AI",
          description: "ALLERGY & IMMUNOLOGY",
        },
        ConcertAI: {
          code: "AI",
          description: "ALLERGY & IMMUNOLOGY",
        },
        MDM: {
          code: "AI",
          description: "ALLERGY & IMMUNOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "TCHP",
          description: "TECHNOLOGIST - PATHOLOGY",
        },

        Onekey: {
          code: "TCHP",
          description: "TECHNOLOGIST - PATHOLOGY",
        },
        XPT: {
          code: "TCHP",
          description: "TECHNOLOGIST - PATHOLOGY",
        },
        ConcertAI: {
          code: "TCHP",
          description: "TECHNOLOGIST - PATHOLOGY",
        },
        MDM: {
          code: "TCHP",
          description: "TECHNOLOGIST - PATHOLOGY",
        },
      },
      {
        "Canonical Value": { code: "OPT", description: "OPTOMETRIST" },

        Onekey: {
          code: "OPT",
          description: "OPTOMETRIST",
        },
        XPT: {
          code: "OPT",
          description: "OPTOMETRIST",
        },
        ConcertAI: {
          code: "OPT",
          description: "OPTOMETRIST",
        },
        MDM: {
          code: "OPT",
          description: "OPTOMETRIST",
        },
      },
      {
        "Canonical Value": {
          code: "EMS",
          description: "EMERGENCY MEDICINE",
        },

        Onekey: {
          code: "EMS",
          description: "EMERGENCY MEDICAL SERVICES",
        },
        XPT: {
          code: "EMS",
          description: "EMERGENCY MEDICAL SERVICES",
        },
        ConcertAI: {
          code: "EMS",
          description: "EMERGENCY MEDICAL SERVICES",
        },
        MDM: {
          code: "EMS",
          description: "EMERGENCY MEDICAL SERVICES",
        },
      },
      {
        "Canonical Value": {
          code: "UP",
          description: "PEDIATRIC UROLOGY",
        },

        Onekey: {
          code: "UP",
          description: "PEDIATRIC UROLOGY",
        },
        XPT: {
          code: "UP",
          description: "PEDIATRIC UROLOGY",
        },
        ConcertAI: {
          code: "UP",
          description: "PEDIATRIC UROLOGY",
        },
        MDM: {
          code: "UP",
          description: "PEDIATRIC UROLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "ISM",
          description: "SPORTS MEDICINE (INTERNAL MEDICINE)",
        },

        Onekey: {
          code: "ISM",
          description: "SPORTS MEDICINE (INTERNAL MEDICINE)",
        },
        XPT: {
          code: "ISM",
          description: "SPORTS MEDICINE (INTERNAL MEDICINE)",
        },
        ConcertAI: {
          code: "ISM",
          description: "SPORTS MEDICINE (INTERNAL MEDICINE)",
        },
        MDM: {
          code: "ISM",
          description: "SPORTS MEDICINE (INTERNAL MEDICINE)",
        },
      },
      {
        "Canonical Value": {
          code: "OBG",
          description: "OBSTETRICS & GYNECOLOGY",
        },

        Onekey: {
          code: "OBG",
          description: "OBSTETRICS & GYNECOLOGY",
        },
        XPT: {
          code: "OBG",
          description: "OBSTETRICS & GYNECOLOGY",
        },
        ConcertAI: {
          code: "OBG",
          description: "OBSTETRICS & GYNECOLOGY",
        },
        MDM: {
          code: "OBG",
          description: "OBSTETRICS & GYNECOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "263",
          description: "Administrative Office",
        },

        Onekey: {
          code: "263",
          description: "Administrative Office",
        },
        XPT: {
          code: "263",
          description: "Administrative Office",
        },
        ConcertAI: {
          code: "263",
          description: "Administrative Office",
        },
        MDM: {
          code: "263",
          description: "Administrative Office",
        },
      },
      {
        "Canonical Value": {
          code: "IRI",
          description: "INTERVENTIONAL RADIOLOGY-INTEGRATED",
        },

        Onekey: {
          code: "IRI",
          description: "INTERVENTIONAL RADIOLOGY-INTEGRATED",
        },
        XPT: {
          code: "IRI",
          description: "INTERVENTIONAL RADIOLOGY-INTEGRATED",
        },
        ConcertAI: {
          code: "IRI",
          description: "INTERVENTIONAL RADIOLOGY-INTEGRATED",
        },
        MDM: {
          code: "IRI",
          description: "INTERVENTIONAL RADIOLOGY-INTEGRATED",
        },
      },
      {
        "Canonical Value": {
          code: "ONM",
          description: "OSTEOPATHIC NEUROMUSCULOSKELETAL MEDICINE",
        },

        Onekey: {
          code: "ONM",
          description: "OSTEOPATHIC NEUROMUSCULOSKELETAL MEDICINE",
        },
        XPT: {
          code: "ONM",
          description: "OSTEOPATHIC NEUROMUSCULOSKELETAL MEDICINE",
        },
        ConcertAI: {
          code: "ONM",
          description: "OSTEOPATHIC NEUROMUSCULOSKELETAL MEDICINE",
        },
        MDM: {
          code: "ONM",
          description: "OSTEOPATHIC NEUROMUSCULOSKELETAL MEDICINE",
        },
      },
      {
        "Canonical Value": {
          code: "DR",
          description: "DIAGNOSTIC RADIOLOGY",
        },

        Onekey: {
          code: "DR",
          description: "DIAGNOSTIC RADIOLOGY",
        },
        XPT: {
          code: "DR",
          description: "DIAGNOSTIC RADIOLOGY",
        },
        ConcertAI: {
          code: "DR",
          description: "DIAGNOSTIC RADIOLOGY",
        },
        MDM: {
          code: "DR",
          description: "DIAGNOSTIC RADIOLOGY",
        },
      },
      {
        "Canonical Value": {
          code: "CIE",
          description: "CLINICAL INFORMATICS (EM)",
        },

        Onekey: {
          code: "CIE",
          description: "CLINICAL INFORMATICS (EM)",
        },
        XPT: {
          code: "CIE",
          description: "CLINICAL INFORMATICS (EM)",
        },
        ConcertAI: {
          code: "CIE",
          description: "CLINICAL INFORMATICS (EM)",
        },
        MDM: {
          code: "CIE",
          description: "CLINICAL INFORMATICS (EM)",
        },
      },
      {
        "Canonical Value": {
          code: "ALI",
          description: "CLINICAL LAB IMMUNOLOGY (ALR & IMM)",
        },

        Onekey: {
          code: "ALI",
          description: "CLINICAL LAB IMMUNOLOGY (ALR & IMM)",
        },
        XPT: {
          code: "ALI",
          description: "CLINICAL LAB IMMUNOLOGY (ALR & IMM)",
        },
        ConcertAI: {
          code: "ALI",
          description: "CLINICAL LAB IMMUNOLOGY (ALR & IMM)",
        },
        MDM: {
          code: "ALI",
          description: "CLINICAL LAB IMMUNOLOGY (ALR & IMM)",
        },
      },
    ],
  },
  {
    name: "Country",
    startdate: "2022-08-01",
    enddate: "2022-08-15",
    sourcevalues: 242,
    unmappedvalues: 3,
    tableData: [
      {
        "Canonical Value": {
          description: "United States of America",
          code: "USA",
        },
        Onekey: {
          description: "United States",
          code: "USA",
        },
        XPT: {
          description: "America",
          code: "US",
        },
        ConcertAI: {
          description: "America",
          code: "United States",
        },
        MDM: {
          description: "America",
          code: "USA",
        },
      },
      {
        "Canonical Value": {
          description: "Aruba",
          code: "AW",
        },

        Onekey: {
          description: "Aruba",
          code: "AW",
        },
        XPT: {
          description: "Aruba",
          code: "AW",
        },
        ConcertAI: {
          description: "Aruba",
          code: "AW",
        },
        MDM: {
          description: "Aruba",
          code: "AW",
        },
      },
      {
        "Canonical Value": {
          description: "Afghanistan",
          code: "AF",
        },

        Onekey: {
          description: "Afghanistan",
          code: "AF",
        },
        XPT: {
          description: "Afghanistan",
          code: "AF",
        },
        ConcertAI: {
          description: "Afghanistan",
          code: "AF",
        },
        MDM: {
          description: "Afghanistan",
          code: "AF",
        },
      },
      {
        "Canonical Value": {
          description: "Angola",
          code: "AO",
        },

        Onekey: {
          description: "Angola",
          code: "AO",
        },
        XPT: {
          description: "Angola",
          code: "AO",
        },
        ConcertAI: {
          description: "Angola",
          code: "AO",
        },
        MDM: {
          description: "Angola",
          code: "AO",
        },
      },
      {
        "Canonical Value": {
          description: "Anguilla",
          code: "AI",
        },

        Onekey: {
          description: "Anguilla",
          code: "AI",
        },
        XPT: {
          description: "Anguilla",
          code: "AI",
        },
        ConcertAI: {
          description: "Anguilla",
          code: "AI",
        },
        MDM: {
          description: "Anguilla",
          code: "AI",
        },
      },
      {
        "Canonical Value": {
          description: "land Islands",
          code: "AX",
        },
        Onekey: {
          description: "\u00c5land Islands",
          code: "AX",
        },
        XPT: {
          description: "\u00c5land Islands",
          code: "AX",
        },
        ConcertAI: {
          description: "\u00c5land Islands",
          code: "AX",
        },
        MDM: {
          description: "\u00c5land Islands",
          code: "AX",
        },
      },
      {
        "Canonical Value": {
          description: "Albania",
          code: "AL",
        },
        Onekey: {
          description: "Albania",
          code: "AL",
        },
        XPT: {
          description: "Albania",
          code: "AL",
        },
        ConcertAI: {
          description: "Albania",
          code: "AL",
        },
        MDM: {
          description: "Albania",
          code: "AL",
        },
      },
      {
        "Canonical Value": {
          description: "Andorra",
          code: "AD",
        },
        Onekey: {
          description: "Andorra",
          code: "AD",
        },
        XPT: {
          description: "Andorra",
          code: "AD",
        },
        ConcertAI: {
          description: "Andorra",
          code: "AD",
        },
        MDM: {
          description: "Andorra",
          code: "AD",
        },
      },
      {
        "Canonical Value": {
          description: "United Arab Emirates",
          code: "AE",
        },
        Onekey: {
          description: "United Arab Emirates",
          code: "AE",
        },
        XPT: {
          description: "United Arab Emirates",
          code: "AE",
        },
        ConcertAI: {
          description: "United Arab Emirates",
          code: "AE",
        },
        MDM: {
          description: "United Arab Emirates",
          code: "AE",
        },
      },
      {
        "Canonical Value": {
          description: "Argentina",
          code: "AR",
        },
        Onekey: {
          description: "Argentina",
          code: "AR",
        },
        XPT: {
          description: "Argentina",
          code: "AR",
        },
        ConcertAI: {
          description: "Argentina",
          code: "AR",
        },
        MDM: {
          description: "Argentina",
          code: "AR",
        },
      },
      {
        "Canonical Value": {
          description: "Armenia",
          code: "AM",
        },
        Onekey: {
          description: "Armenia",
          code: "AM",
        },
        XPT: {
          description: "Armenia",
          code: "AM",
        },
        ConcertAI: {
          description: "Armenia",
          code: "AM",
        },
        MDM: {
          description: "Armenia",
          code: "AM",
        },
      },
      {
        "Canonical Value": {
          description: "Antarctica",
          code: "AQ",
        },
        Onekey: {
          description: "Antarctica",
          code: "AQ",
        },
        XPT: {
          description: "Antarctica",
          code: "AQ",
        },
        ConcertAI: {
          description: "Antarctica",
          code: "AQ",
        },
        MDM: {
          description: "Antarctica",
          code: "AQ",
        },
      },
      {
        "Canonical Value": {
          description: "French Southern Territories",
          code: "TF",
        },
        Onekey: {
          description: "French Southern Territories",
          code: "TF",
        },
        XPT: {
          description: "French Southern Territories",
          code: "TF",
        },
        ConcertAI: {
          description: "French Southern Territories",
          code: "TF",
        },
        MDM: {
          description: "French Southern Territories",
          code: "TF",
        },
      },
      {
        "Canonical Value": {
          description: "Antigua and Barbuda",
          code: "AG",
        },
        Onekey: {
          description: "Antigua and Barbuda",
          code: "AG",
        },
        XPT: {
          description: "Antigua and Barbuda",
          code: "AG",
        },
        ConcertAI: {
          description: "Antigua and Barbuda",
          code: "AG",
        },
        MDM: {
          description: "Antigua and Barbuda",
          code: "AG",
        },
      },
      {
        "Canonical Value": {
          description: "Australia",
          code: "AU",
        },
        Onekey: {
          description: "Australia",
          code: "AU",
        },
        XPT: {
          description: "Australia",
          code: "AU",
        },
        ConcertAI: {
          description: "Australia",
          code: "AU",
        },
        MDM: {
          description: "Australia",
          code: "AU",
        },
      },
      {
        "Canonical Value": {
          description: "Austria",
          code: "AT",
        },
        Onekey: {
          description: "Austria",
          code: "AT",
        },
        XPT: {
          description: "Austria",
          code: "AT",
        },
        ConcertAI: {
          description: "Austria",
          code: "AT",
        },
        MDM: {
          description: "Austria",
          code: "AT",
        },
      },
      {
        "Canonical Value": {
          description: "Azerbaijan",
          code: "AZ",
        },
        Onekey: {
          description: "Azerbaijan",
          code: "AZ",
        },
        XPT: {
          description: "Azerbaijan",
          code: "AZ",
        },
        ConcertAI: {
          description: "Azerbaijan",
          code: "AZ",
        },
        MDM: {
          description: "Azerbaijan",
          code: "AZ",
        },
      },
      {
        "Canonical Value": {
          description: "Burundi",
          code: "BI",
        },
        Onekey: {
          description: "Burundi",
          code: "BI",
        },
        XPT: {
          description: "Burundi",
          code: "BI",
        },
        ConcertAI: {
          description: "Burundi",
          code: "BI",
        },
        MDM: {
          description: "Burundi",
          code: "BI",
        },
      },
      {
        "Canonical Value": {
          description: "Belgium",
          code: "BE",
        },
        Onekey: {
          description: "Belgium",
          code: "BE",
        },
        XPT: {
          description: "Belgium",
          code: "BE",
        },
        ConcertAI: {
          description: "Belgium",
          code: "BE",
        },
        MDM: {
          description: "Belgium",
          code: "BE",
        },
      },
      {
        "Canonical Value": {
          description: "Benin",
          code: "BJ",
        },
        Onekey: {
          description: "Benin",
          code: "BJ",
        },
        XPT: {
          description: "Benin",
          code: "BJ",
        },
        ConcertAI: {
          description: "Benin",
          code: "BJ",
        },
        MDM: {
          description: "Benin",
          code: "BJ",
        },
      },
      {
        "Canonical Value": {
          description: "Bonaire, Sint Eustatius and Saba",
          code: "BQ",
        },
        Onekey: {
          description: "Bonaire, Sint Eustatius and Saba",
          code: "BQ",
        },
        XPT: {
          description: "Bonaire, Sint Eustatius and Saba",
          code: "BQ",
        },
        ConcertAI: {
          description: "Bonaire, Sint Eustatius and Saba",
          code: "BQ",
        },
        MDM: {
          description: "Bonaire, Sint Eustatius and Saba",
          code: "BQ",
        },
      },
      {
        "Canonical Value": {
          description: "Burkina Faso",
          code: "BF",
        },
        Onekey: {
          description: "Burkina Faso",
          code: "BF",
        },
        XPT: {
          description: "Burkina Faso",
          code: "BF",
        },
        ConcertAI: {
          description: "Burkina Faso",
          code: "BF",
        },
        MDM: {
          description: "Burkina Faso",
          code: "BF",
        },
      },
      {
        "Canonical Value": {
          description: "Bangladesh",
          code: "BD",
        },
        Onekey: {
          description: "Bangladesh",
          code: "BD",
        },
        XPT: {
          description: "Bangladesh",
          code: "BD",
        },
        ConcertAI: {
          description: "Bangladesh",
          code: "BD",
        },
        MDM: {
          description: "Bangladesh",
          code: "BD",
        },
      },
      {
        "Canonical Value": {
          description: "Bulgaria",
          code: "BG",
        },
        Onekey: {
          description: "Bulgaria",
          code: "BG",
        },
        XPT: {
          description: "Bulgaria",
          code: "BG",
        },
        ConcertAI: {
          description: "Bulgaria",
          code: "BG",
        },
        MDM: {
          description: "Bulgaria",
          code: "BG",
        },
      },
      {
        "Canonical Value": {
          description: "Bahrain",
          code: "BH",
        },
        Onekey: {
          description: "Bahrain",
          code: "BH",
        },
        XPT: {
          description: "Bahrain",
          code: "BH",
        },
        ConcertAI: {
          description: "Bahrain",
          code: "BH",
        },
        MDM: {
          description: "Bahrain",
          code: "BH",
        },
      },
      {
        "Canonical Value": {
          description: "Bahamas",
          code: "BS",
        },
        Onekey: {
          description: "Bahamas",
          code: "BS",
        },
        XPT: {
          description: "Bahamas",
          code: "BS",
        },
        ConcertAI: {
          description: "Bahamas",
          code: "BS",
        },
        MDM: {
          description: "Bahamas",
          code: "BS",
        },
      },
      {
        "Canonical Value": {
          description: "Bosnia and Herzegovina",
          code: "BA",
        },
        Onekey: {
          description: "Bosnia and Herzegovina",
          code: "BA",
        },
        XPT: {
          description: "Bosnia and Herzegovina",
          code: "BA",
        },
        ConcertAI: {
          description: "Bosnia and Herzegovina",
          code: "BA",
        },
        MDM: {
          description: "Bosnia and Herzegovina",
          code: "BA",
        },
      },
      {
        "Canonical Value": {
          description: "Saint Barthélemy",
          code: "BL",
        },
        Onekey: {
          description: "Saint Barthélemy",
          code: "BL",
        },
        XPT: {
          description: "Saint Barthélemy",
          code: "BL",
        },
        ConcertAI: {
          description: "Saint Barthélemy",
          code: "BL",
        },
        MDM: {
          description: "Saint Barthélemy",
          code: "BL",
        },
      },
      {
        "Canonical Value": {
          description: "Belarus",
          code: "BY",
        },
        Onekey: {
          description: "Belarus",
          code: "BY",
        },
        XPT: {
          description: "Belarus",
          code: "BY",
        },
        ConcertAI: {
          description: "Belarus",
          code: "BY",
        },
        MDM: {
          description: "Belarus",
          code: "BY",
        },
      },
      {
        "Canonical Value": {
          description: "Belize",
          code: "BZ",
        },
        Onekey: {
          description: "Belize",
          code: "BZ",
        },
        XPT: {
          description: "Belize",
          code: "BZ",
        },
        ConcertAI: {
          description: "Belize",
          code: "BZ",
        },
        MDM: {
          description: "Belize",
          code: "BZ",
        },
      },
      {
        "Canonical Value": {
          description: "Bermuda",
          code: "BM",
        },
        Onekey: {
          description: "Bermuda",
          code: "BM",
        },
        XPT: {
          description: "Bermuda",
          code: "BM",
        },
        ConcertAI: {
          description: "Bermuda",
          code: "BM",
        },
        MDM: {
          description: "Bermuda",
          code: "BM",
        },
      },
      {
        "Canonical Value": {
          description: "Bolivia, Plurinational State of",
          code: "BO",
        },
        Onekey: {
          description: "Bolivia, Plurinational State of",
          code: "BO",
        },
        XPT: {
          description: "Bolivia, Plurinational State of",
          code: "BO",
        },
        ConcertAI: {
          description: "Bolivia, Plurinational State of",
          code: "BO",
        },
        MDM: {
          description: "Bolivia, Plurinational State of",
          code: "BO",
        },
      },
      {
        "Canonical Value": {
          description: "Brazil",
          code: "BR",
        },
        Onekey: {
          description: "Brazil",
          code: "BR",
        },
        XPT: {
          description: "Brazil",
          code: "BR",
        },
        ConcertAI: {
          description: "Brazil",
          code: "BR",
        },
        MDM: {
          description: "Brazil",
          code: "BR",
        },
      },
      {
        "Canonical Value": {
          description: "Barbados",
          code: "BB",
        },
        Onekey: {
          description: "Barbados",
          code: "BB",
        },
        XPT: {
          description: "Barbados",
          code: "BB",
        },
        ConcertAI: {
          description: "Barbados",
          code: "BB",
        },
        MDM: {
          description: "Barbados",
          code: "BB",
        },
      },
      {
        "Canonical Value": {
          description: "Brunei Darussalam",
          code: "BN",
        },
        Onekey: {
          description: "Brunei Darussalam",
          code: "BN",
        },
        XPT: {
          description: "Brunei Darussalam",
          code: "BN",
        },
        ConcertAI: {
          description: "Brunei Darussalam",
          code: "BN",
        },
        MDM: {
          description: "Brunei Darussalam",
          code: "BN",
        },
      },
      {
        "Canonical Value": {
          description: "Bhutan",
          code: "BT",
        },
        Onekey: {
          description: "Bhutan",
          code: "BT",
        },
        XPT: {
          description: "Bhutan",
          code: "BT",
        },
        ConcertAI: {
          description: "Bhutan",
          code: "BT",
        },
        MDM: {
          description: "Bhutan",
          code: "BT",
        },
      },
      {
        "Canonical Value": {
          description: "Bouvet Island",
          code: "BV",
        },

        Onekey: {
          description: "Bouvet Island",
          code: "BV",
        },
        XPT: {
          description: "Bouvet Island",
          code: "BV",
        },
        ConcertAI: {
          description: "Bouvet Island",
          code: "BV",
        },
        MDM: {
          description: "Bouvet Island",
          code: "BV",
        },
      },
      {
        "Canonical Value": {
          description: "Botswana",
          code: "BW",
        },
        Onekey: {
          description: "Botswana",
          code: "BW",
        },
        XPT: {
          description: "Botswana",
          code: "BW",
        },
        ConcertAI: {
          description: "Botswana",
          code: "BW",
        },
        MDM: {
          description: "Botswana",
          code: "BW",
        },
      },
      {
        "Canonical Value": {
          description: "Central African Republic",
          code: "CF",
        },
        Onekey: {
          description: "Central African Republic",
          code: "CF",
        },
        XPT: {
          description: "Central African Republic",
          code: "CF",
        },
        ConcertAI: {
          description: "Central African Republic",
          code: "CF",
        },
        MDM: {
          description: "Central African Republic",
          code: "CF",
        },
      },
      {
        "Canonical Value": {
          description: "Canada",
          code: "CA",
        },
        Onekey: {
          description: "Canada",
          code: "CA",
        },
        XPT: {
          description: "Canada",
          code: "CA",
        },
        ConcertAI: {
          description: "Canada",
          code: "CA",
        },
        MDM: {
          description: "Canada",
          code: "CA",
        },
      },
      {
        "Canonical Value": {
          description: "Cocos (Keeling) Islands",
          code: "CC",
        },
        Onekey: {
          description: "Cocos (Keeling) Islands",
          code: "CC",
        },
        XPT: {
          description: "Cocos (Keeling) Islands",
          code: "CC",
        },
        ConcertAI: {
          description: "Cocos (Keeling) Islands",
          code: "CC",
        },
        MDM: {
          description: "Cocos (Keeling) Islands",
          code: "CC",
        },
      },
      {
        "Canonical Value": {
          description: "Switzerland",
          code: "CH",
        },
        Onekey: {
          description: "Switzerland",
          code: "CH",
        },
        XPT: {
          description: "Switzerland",
          code: "CH",
        },
        ConcertAI: {
          description: "Switzerland",
          code: "CH",
        },
        MDM: {
          description: "Switzerland",
          code: "CH",
        },
      },
      {
        "Canonical Value": {
          description: "Chile",
          code: "CL",
        },
        Onekey: {
          description: "Chile",
          code: "CL",
        },
        XPT: {
          description: "Chile",
          code: "CL",
        },
        ConcertAI: {
          description: "Chile",
          code: "CL",
        },
        MDM: {
          description: "Chile",
          code: "CL",
        },
      },
      {
        "Canonical Value": {
          description: "China",
          code: "CN",
        },
        Onekey: {
          description: "China",
          code: "CN",
        },
        XPT: {
          description: "China",
          code: "CN",
        },
        ConcertAI: {
          description: "China",
          code: "CN",
        },
        MDM: {
          description: "China",
          code: "CN",
        },
      },
      {
        "Canonical Value": {
          description: "Côte d'Ivoire",
          code: "CI",
        },
        Onekey: {
          description: "Côte d'Ivoire",
          code: "CI",
        },
        XPT: {
          description: "Côte d'Ivoire",
          code: "CI",
        },
        ConcertAI: {
          description: "Côte d'Ivoire",
          code: "CI",
        },
        MDM: {
          description: "Côte d'Ivoire",
          code: "CI",
        },
      },
      {
        "Canonical Value": {
          description: "Cameroon",
          code: "CM",
        },
        Onekey: {
          description: "Cameroon",
          code: "CM",
        },
        XPT: {
          description: "Cameroon",
          code: "CM",
        },
        ConcertAI: {
          description: "Cameroon",
          code: "CM",
        },
        MDM: {
          description: "Cameroon",
          code: "CM",
        },
      },
      {
        "Canonical Value": {
          description: "Congo, The Democratic Republic of the",
          code: "CD",
        },
        Onekey: {
          description: "Congo, The Democratic Republic of the",
          code: "CD",
        },
        XPT: {
          description: "Congo, The Democratic Republic of the",
          code: "CD",
        },
        ConcertAI: {
          description: "Congo, The Democratic Republic of the",
          code: "CD",
        },
        MDM: {
          description: "Congo, The Democratic Republic of the",
          code: "CD",
        },
      },
      {
        "Canonical Value": {
          description: "Congo",
          code: "CG",
        },
        Onekey: {
          description: "Congo",
          code: "CG",
        },
        XPT: {
          description: "Congo",
          code: "CG",
        },
        ConcertAI: {
          description: "Congo",
          code: "CG",
        },
        MDM: {
          description: "Congo",
          code: "CG",
        },
      },
      {
        "Canonical Value": {
          description: "Cook Islands",
          code: "CK",
        },
        Onekey: {
          description: "Cook Islands",
          code: "CK",
        },
        XPT: {
          description: "Cook Islands",
          code: "CK",
        },
        ConcertAI: {
          description: "Cook Islands",
          code: "CK",
        },
        MDM: {
          description: "Cook Islands",
          code: "CK",
        },
      },
      {
        "Canonical Value": {
          description: "Colombia",
          code: "CO",
        },
        Onekey: {
          description: "Colombia",
          code: "CO",
        },
        XPT: {
          description: "Colombia",
          code: "CO",
        },
        ConcertAI: {
          description: "Colombia",
          code: "CO",
        },
        MDM: {
          description: "Colombia",
          code: "CO",
        },
      },
      {
        "Canonical Value": {
          description: "Comoros",
          code: "KM",
        },
        Onekey: {
          description: "Comoros",
          code: "KM",
        },
        XPT: {
          description: "Comoros",
          code: "KM",
        },
        ConcertAI: {
          description: "Comoros",
          code: "KM",
        },
        MDM: {
          description: "Comoros",
          code: "KM",
        },
      },
      {
        "Canonical Value": {
          description: "Cabo Verde",
          code: "CV",
        },
        Onekey: {
          description: "Cabo Verde",
          code: "CV",
        },
        XPT: {
          description: "Cabo Verde",
          code: "CV",
        },
        ConcertAI: {
          description: "Cabo Verde",
          code: "CV",
        },
        MDM: {
          description: "Cabo Verde",
          code: "CV",
        },
      },
      {
        "Canonical Value": {
          description: "Costa Rica",
          code: "CR",
        },
        Onekey: {
          description: "Costa Rica",
          code: "CR",
        },
        XPT: {
          description: "Costa Rica",
          code: "CR",
        },
        ConcertAI: {
          description: "Costa Rica",
          code: "CR",
        },
        MDM: {
          description: "Costa Rica",
          code: "CR",
        },
      },
      {
        "Canonical Value": {
          description: "Cuba",
          code: "CU",
        },
        Onekey: {
          description: "Cuba",
          code: "CU",
        },
        XPT: {
          description: "Cuba",
          code: "CU",
        },
        ConcertAI: {
          description: "Cuba",
          code: "CU",
        },
        MDM: {
          description: "Cuba",
          code: "CU",
        },
      },
      {
        "Canonical Value": {
          description: "Curaçao",
          code: "CW",
        },
        Onekey: {
          description: "Curaçao",
          code: "CW",
        },
        XPT: {
          description: "Curaçao",
          code: "CW",
        },
        ConcertAI: {
          description: "Curaçao",
          code: "CW",
        },
        MDM: {
          description: "Curaçao",
          code: "CW",
        },
      },
      {
        "Canonical Value": {
          description: "Christmas Island",
          code: "CX",
        },
        Onekey: {
          description: "Christmas Island",
          code: "CX",
        },
        XPT: {
          description: "Christmas Island",
          code: "CX",
        },
        ConcertAI: {
          description: "Christmas Island",
          code: "CX",
        },
        MDM: {
          description: "Christmas Island",
          code: "CX",
        },
      },
      {
        "Canonical Value": {
          description: "Cayman Islands",
          code: "KY",
        },
        Onekey: {
          description: "Cayman Islands",
          code: "KY",
        },
        XPT: {
          description: "Cayman Islands",
          code: "KY",
        },
        ConcertAI: {
          description: "Cayman Islands",
          code: "KY",
        },
        MDM: {
          description: "Cayman Islands",
          code: "KY",
        },
      },
      {
        "Canonical Value": {
          description: "Cyprus",
          code: "CY",
        },
        Onekey: {
          description: "Cyprus",
          code: "CY",
        },
        XPT: {
          description: "Cyprus",
          code: "CY",
        },
        ConcertAI: {
          description: "Cyprus",
          code: "CY",
        },
        MDM: {
          description: "Cyprus",
          code: "CY",
        },
      },
      {
        "Canonical Value": {
          description: "Czechia",
          code: "CZ",
        },
        Onekey: {
          description: "Czechia",
          code: "CZ",
        },
        XPT: {
          description: "Czechia",
          code: "CZ",
        },
        ConcertAI: {
          description: "Czechia",
          code: "CZ",
        },
        MDM: {
          description: "Czechia",
          code: "CZ",
        },
      },
      {
        "Canonical Value": {
          description: "Germany",
          code: "DE",
        },
        Onekey: {
          description: "Germany",
          code: "DE",
        },
        XPT: {
          description: "Germany",
          code: "DE",
        },
        ConcertAI: {
          description: "Germany",
          code: "DE",
        },
        MDM: {
          description: "Germany",
          code: "DE",
        },
      },
      {
        "Canonical Value": {
          description: "Djibouti",
          code: "DJ",
        },
        Onekey: {
          description: "Djibouti",
          code: "DJ",
        },
        XPT: {
          description: "Djibouti",
          code: "DJ",
        },
        ConcertAI: {
          description: "Djibouti",
          code: "DJ",
        },
        MDM: {
          description: "Djibouti",
          code: "DJ",
        },
      },
      {
        "Canonical Value": {
          description: "Dominica",
          code: "DM",
        },
        Onekey: {
          description: "Dominica",
          code: "DM",
        },
        XPT: {
          description: "Dominica",
          code: "DM",
        },
        ConcertAI: {
          description: "Dominica",
          code: "DM",
        },
        MDM: {
          description: "Dominica",
          code: "DM",
        },
      },
      {
        "Canonical Value": {
          description: "Denmark",
          code: "DK",
        },
        Onekey: {
          description: "Denmark",
          code: "DK",
        },
        XPT: {
          description: "Denmark",
          code: "DK",
        },
        ConcertAI: {
          description: "Denmark",
          code: "DK",
        },
        MDM: {
          description: "Denmark",
          code: "DK",
        },
      },
      {
        "Canonical Value": {
          description: "Dominican Republic",
          code: "DO",
        },
        Onekey: {
          description: "Dominican Republic",
          code: "DO",
        },
        XPT: {
          description: "Dominican Republic",
          code: "DO",
        },
        ConcertAI: {
          description: "Dominican Republic",
          code: "DO",
        },
        MDM: {
          description: "Dominican Republic",
          code: "DO",
        },
      },
      {
        "Canonical Value": {
          description: "Algeria",
          code: "DZ",
        },
        Onekey: {
          description: "Algeria",
          code: "DZ",
        },
        XPT: {
          description: "Algeria",
          code: "DZ",
        },
        ConcertAI: {
          description: "Algeria",
          code: "DZ",
        },
        MDM: {
          description: "Algeria",
          code: "DZ",
        },
      },
      {
        "Canonical Value": {
          description: "Ecuador",
          code: "EC",
        },
        Onekey: {
          description: "Ecuador",
          code: "EC",
        },
        XPT: {
          description: "Ecuador",
          code: "EC",
        },
        ConcertAI: {
          description: "Ecuador",
          code: "EC",
        },
        MDM: {
          description: "Ecuador",
          code: "EC",
        },
      },
      {
        "Canonical Value": {
          description: "Egypt",
          code: "EG",
        },
        Onekey: {
          description: "Egypt",
          code: "EG",
        },
        XPT: {
          description: "Egypt",
          code: "EG",
        },
        ConcertAI: {
          description: "Egypt",
          code: "EG",
        },
        MDM: {
          description: "Egypt",
          code: "EG",
        },
      },
      {
        "Canonical Value": {
          description: "Eritrea",
          code: "ER",
        },
        Onekey: {
          description: "Eritrea",
          code: "ER",
        },
        XPT: {
          description: "Eritrea",
          code: "ER",
        },
        ConcertAI: {
          description: "Eritrea",
          code: "ER",
        },
        MDM: {
          description: "Eritrea",
          code: "ER",
        },
      },
      {
        "Canonical Value": {
          description: "Western Sahara",
          code: "EH",
        },
        Onekey: {
          description: "Western Sahara",
          code: "EH",
        },
        XPT: {
          description: "Western Sahara",
          code: "EH",
        },
        ConcertAI: {
          description: "Western Sahara",
          code: "EH",
        },
        MDM: {
          description: "Western Sahara",
          code: "EH",
        },
      },
      {
        "Canonical Value": {
          description: "Spain",
          code: "ES",
        },
        Onekey: {
          description: "Spain",
          code: "ES",
        },
        XPT: {
          description: "Spain",
          code: "ES",
        },
        ConcertAI: {
          description: "Spain",
          code: "ES",
        },
        MDM: {
          description: "Spain",
          code: "ES",
        },
      },
      {
        "Canonical Value": {
          description: "Estonia",
          code: "EE",
        },
        Onekey: {
          description: "Estonia",
          code: "EE",
        },
        XPT: {
          description: "Estonia",
          code: "EE",
        },
        ConcertAI: {
          description: "Estonia",
          code: "EE",
        },
        MDM: {
          description: "Estonia",
          code: "EE",
        },
      },
      {
        "Canonical Value": {
          description: "Ethiopia",
          code: "ET",
        },
        Onekey: {
          description: "Ethiopia",
          code: "ET",
        },
        XPT: {
          description: "Ethiopia",
          code: "ET",
        },
        ConcertAI: {
          description: "Ethiopia",
          code: "ET",
        },
        MDM: {
          description: "Ethiopia",
          code: "ET",
        },
      },
      {
        "Canonical Value": {
          description: "Finland",
          code: "FI",
        },
        Onekey: {
          description: "Finland",
          code: "FI",
        },
        XPT: {
          description: "Finland",
          code: "FI",
        },
        ConcertAI: {
          description: "Finland",
          code: "FI",
        },
        MDM: {
          description: "Finland",
          code: "FI",
        },
      },
      {
        "Canonical Value": {
          description: "Fiji",
          code: "FJ",
        },
        Onekey: {
          description: "Fiji",
          code: "FJ",
        },
        XPT: {
          description: "Fiji",
          code: "FJ",
        },
        ConcertAI: {
          description: "Fiji",
          code: "FJ",
        },
        MDM: {
          description: "Fiji",
          code: "FJ",
        },
      },
      {
        "Canonical Value": {
          description: "Falkland Islands (Malvinas)",
          code: "FK",
        },
        Onekey: {
          description: "Falkland Islands (Malvinas)",
          code: "FK",
        },
        XPT: {
          description: "Falkland Islands (Malvinas)",
          code: "FK",
        },
        ConcertAI: {
          description: "Falkland Islands (Malvinas)",
          code: "FK",
        },
        MDM: {
          description: "Falkland Islands (Malvinas)",
          code: "FK",
        },
      },
      {
        "Canonical Value": {
          description: "France",
          code: "FR",
        },
        Onekey: {
          description: "France",
          code: "FR",
        },
        XPT: {
          description: "France",
          code: "FR",
        },
        ConcertAI: {
          description: "France",
          code: "FR",
        },
        MDM: {
          description: "France",
          code: "FR",
        },
      },
      {
        "Canonical Value": {
          description: "Faroe Islands",
          code: "FO",
        },
        Onekey: {
          description: "Faroe Islands",
          code: "FO",
        },
        XPT: {
          description: "Faroe Islands",
          code: "FO",
        },
        ConcertAI: {
          description: "Faroe Islands",
          code: "FO",
        },
        MDM: {
          description: "Faroe Islands",
          code: "FO",
        },
      },
      {
        "Canonical Value": {
          description: "Micronesia, Federated States of",
          code: "FM",
        },
        Onekey: {
          description: "Micronesia, Federated States of",
          code: "FM",
        },
        XPT: {
          description: "Micronesia, Federated States of",
          code: "FM",
        },
        ConcertAI: {
          description: "Micronesia, Federated States of",
          code: "FM",
        },
        MDM: {
          description: "Micronesia, Federated States of",
          code: "FM",
        },
      },
      {
        "Canonical Value": {
          description: "Gabon",
          code: "GA",
        },
        Onekey: {
          description: "Gabon",
          code: "GA",
        },
        XPT: {
          description: "Gabon",
          code: "GA",
        },
        ConcertAI: {
          description: "Gabon",
          code: "GA",
        },
        MDM: {
          description: "Gabon",
          code: "GA",
        },
      },
      {
        "Canonical Value": {
          description: "United Kingdom",
          code: "GB",
        },
        Onekey: {
          description: "United Kingdom",
          code: "GB",
        },
        XPT: {
          description: "United Kingdom",
          code: "GB",
        },
        ConcertAI: {
          description: "United Kingdom",
          code: "GB",
        },
        MDM: {
          description: "United Kingdom",
          code: "GB",
        },
      },
      {
        "Canonical Value": {
          description: "Georgia",
          code: "GE",
        },
        Onekey: {
          description: "Georgia",
          code: "GE",
        },
        XPT: {
          description: "Georgia",
          code: "GE",
        },
        ConcertAI: {
          description: "Georgia",
          code: "GE",
        },
        MDM: {
          description: "Georgia",
          code: "GE",
        },
      },
      {
        "Canonical Value": {
          description: "Guernsey",
          code: "GG",
        },
        Onekey: {
          description: "Guernsey",
          code: "GG",
        },
        XPT: {
          description: "Guernsey",
          code: "GG",
        },
        ConcertAI: {
          description: "Guernsey",
          code: "GG",
        },
        MDM: {
          description: "Guernsey",
          code: "GG",
        },
      },
      {
        "Canonical Value": {
          description: "Ghana",
          code: "GH",
        },
        Onekey: {
          description: "Ghana",
          code: "GH",
        },
        XPT: {
          description: "Ghana",
          code: "GH",
        },
        ConcertAI: {
          description: "Ghana",
          code: "GH",
        },
        MDM: {
          description: "Ghana",
          code: "GH",
        },
      },
      {
        "Canonical Value": {
          description: "Gibraltar",
          code: "GI",
        },
        Onekey: {
          description: "Gibraltar",
          code: "GI",
        },
        XPT: {
          description: "Gibraltar",
          code: "GI",
        },
        ConcertAI: {
          description: "Gibraltar",
          code: "GI",
        },
        MDM: {
          description: "Gibraltar",
          code: "GI",
        },
      },
      {
        "Canonical Value": {
          description: "Guinea",
          code: "GN",
        },
        Onekey: {
          description: "Guinea",
          code: "GN",
        },
        XPT: {
          description: "Guinea",
          code: "GN",
        },
        ConcertAI: {
          description: "Guinea",
          code: "GN",
        },
        MDM: {
          description: "Guinea",
          code: "GN",
        },
      },
      {
        "Canonical Value": {
          description: "Guadeloupe",
          code: "GP",
        },
        Onekey: {
          description: "Guadeloupe",
          code: "GP",
        },
        XPT: {
          description: "Guadeloupe",
          code: "GP",
        },
        ConcertAI: {
          description: "Guadeloupe",
          code: "GP",
        },
        MDM: {
          description: "Guadeloupe",
          code: "GP",
        },
      },
      {
        "Canonical Value": {
          description: "Gambia",
          code: "GM",
        },
        Onekey: {
          description: "Gambia",
          code: "GM",
        },
        XPT: {
          description: "Gambia",
          code: "GM",
        },
        ConcertAI: {
          description: "Gambia",
          code: "GM",
        },
        MDM: {
          description: "Gambia",
          code: "GM",
        },
      },
      {
        "Canonical Value": {
          description: "Guinea-Bissau",
          code: "GW",
        },
        Onekey: {
          description: "Guinea-Bissau",
          code: "GW",
        },
        XPT: {
          description: "Guinea-Bissau",
          code: "GW",
        },
        ConcertAI: {
          description: "Guinea-Bissau",
          code: "GW",
        },
        MDM: {
          description: "Guinea-Bissau",
          code: "GW",
        },
      },
      {
        "Canonical Value": {
          description: "Equatorial Guinea",
          code: "GQ",
        },
        Onekey: {
          description: "Equatorial Guinea",
          code: "GQ",
        },
        XPT: {
          description: "Equatorial Guinea",
          code: "GQ",
        },
        ConcertAI: {
          description: "Equatorial Guinea",
          code: "GQ",
        },
        MDM: {
          description: "Equatorial Guinea",
          code: "GQ",
        },
      },
      {
        "Canonical Value": {
          description: "Greece",
          code: "GR",
        },
        Onekey: {
          description: "Greece",
          code: "GR",
        },
        XPT: {
          description: "Greece",
          code: "GR",
        },
        ConcertAI: {
          description: "Greece",
          code: "GR",
        },
        MDM: {
          description: "Greece",
          code: "GR",
        },
      },
      {
        "Canonical Value": {
          description: "Grenada",
          code: "GD",
        },
        Onekey: {
          description: "Grenada",
          code: "GD",
        },
        XPT: {
          description: "Grenada",
          code: "GD",
        },
        ConcertAI: {
          description: "Grenada",
          code: "GD",
        },
        MDM: {
          description: "Grenada",
          code: "GD",
        },
      },
      {
        "Canonical Value": {
          description: "Greenland",
          code: "GL",
        },
        Onekey: {
          description: "Greenland",
          code: "GL",
        },
        XPT: {
          description: "Greenland",
          code: "GL",
        },
        ConcertAI: {
          description: "Greenland",
          code: "GL",
        },
        MDM: {
          description: "Greenland",
          code: "GL",
        },
      },
      {
        "Canonical Value": {
          description: "Guatemala",
          code: "GT",
        },
        Onekey: {
          description: "Guatemala",
          code: "GT",
        },
        XPT: {
          description: "Guatemala",
          code: "GT",
        },
        ConcertAI: {
          description: "Guatemala",
          code: "GT",
        },
        MDM: {
          description: "Guatemala",
          code: "GT",
        },
      },
      {
        "Canonical Value": {
          description: "French Guiana",
          code: "GF",
        },
        Onekey: {
          description: "French Guiana",
          code: "GF",
        },
        XPT: {
          description: "French Guiana",
          code: "GF",
        },
        ConcertAI: {
          description: "French Guiana",
          code: "GF",
        },
        MDM: {
          description: "French Guiana",
          code: "GF",
        },
      },
      {
        "Canonical Value": {
          description: "Guam",
          code: "GU",
        },
        Onekey: {
          description: "Guam",
          code: "GU",
        },
        XPT: {
          description: "Guam",
          code: "GU",
        },
        ConcertAI: {
          description: "Guam",
          code: "GU",
        },
        MDM: {
          description: "Guam",
          code: "GU",
        },
      },
      {
        "Canonical Value": {
          description: "Guyana",
          code: "GY",
        },
        Onekey: {
          description: "Guyana",
          code: "GY",
        },
        XPT: {
          description: "Guyana",
          code: "GY",
        },
        ConcertAI: {
          description: "Guyana",
          code: "GY",
        },
        MDM: {
          description: "Guyana",
          code: "GY",
        },
      },
      {
        "Canonical Value": {
          description: "Hong Kong",
          code: "HK",
        },
        Onekey: {
          description: "Hong Kong",
          code: "HK",
        },
        XPT: {
          description: "Hong Kong",
          code: "HK",
        },
        ConcertAI: {
          description: "Hong Kong",
          code: "HK",
        },
        MDM: {
          description: "Hong Kong",
          code: "HK",
        },
      },
      {
        "Canonical Value": {
          description: "Heard Island and McDonald Islands",
          code: "HM",
        },
        Onekey: {
          description: "Heard Island and McDonald Islands",
          code: "HM",
        },
        XPT: {
          description: "Heard Island and McDonald Islands",
          code: "HM",
        },
        ConcertAI: {
          description: "Heard Island and McDonald Islands",
          code: "HM",
        },
        MDM: {
          description: "Heard Island and McDonald Islands",
          code: "HM",
        },
      },
      {
        "Canonical Value": {
          description: "Honduras",
          code: "HN",
        },
        Onekey: {
          description: "Honduras",
          code: "HN",
        },
        XPT: {
          description: "Honduras",
          code: "HN",
        },
        ConcertAI: {
          description: "Honduras",
          code: "HN",
        },
        MDM: {
          description: "Honduras",
          code: "HN",
        },
      },
      {
        "Canonical Value": {
          description: "Croatia",
          code: "HR",
        },
        Onekey: {
          description: "Croatia",
          code: "HR",
        },
        XPT: {
          description: "Croatia",
          code: "HR",
        },
        ConcertAI: {
          description: "Croatia",
          code: "HR",
        },
        MDM: {
          description: "Croatia",
          code: "HR",
        },
      },
      {
        "Canonical Value": {
          description: "Haiti",
          code: "HT",
        },
        Onekey: {
          description: "Haiti",
          code: "HT",
        },
        XPT: {
          description: "Haiti",
          code: "HT",
        },
        ConcertAI: {
          description: "Haiti",
          code: "HT",
        },
        MDM: {
          description: "Haiti",
          code: "HT",
        },
      },
      {
        "Canonical Value": {
          description: "Hungary",
          code: "HU",
        },
        Onekey: {
          description: "Hungary",
          code: "HU",
        },
        XPT: {
          description: "Hungary",
          code: "HU",
        },
        ConcertAI: {
          description: "Hungary",
          code: "HU",
        },
        MDM: {
          description: "Hungary",
          code: "HU",
        },
      },
      {
        "Canonical Value": {
          description: "Indonesia",
          code: "ID",
        },
        Onekey: {
          description: "Indonesia",
          code: "ID",
        },
        XPT: {
          description: "Indonesia",
          code: "ID",
        },
        ConcertAI: {
          description: "Indonesia",
          code: "ID",
        },
        MDM: {
          description: "Indonesia",
          code: "ID",
        },
      },
      {
        "Canonical Value": {
          description: "Isle of Man",
          code: "IM",
        },
        Onekey: {
          description: "Isle of Man",
          code: "IM",
        },
        XPT: {
          description: "Isle of Man",
          code: "IM",
        },
        ConcertAI: {
          description: "Isle of Man",
          code: "IM",
        },
        MDM: {
          description: "Isle of Man",
          code: "IM",
        },
      },
      {
        "Canonical Value": {
          description: "India",
          code: "IN",
        },
        Onekey: {
          description: "India",
          code: "IN",
        },
        XPT: {
          description: "India",
          code: "IN",
        },
        ConcertAI: {
          description: "India",
          code: "IN",
        },
        MDM: {
          description: "India",
          code: "IN",
        },
      },
      {
        "Canonical Value": {
          description: "British Indian Ocean Territory",
          code: "IO",
        },
        Onekey: {
          description: "British Indian Ocean Territory",
          code: "IO",
        },
        XPT: {
          description: "British Indian Ocean Territory",
          code: "IO",
        },
        ConcertAI: {
          description: "British Indian Ocean Territory",
          code: "IO",
        },
        MDM: {
          description: "British Indian Ocean Territory",
          code: "IO",
        },
      },
      {
        "Canonical Value": {
          description: "Ireland",
          code: "IE",
        },
        Onekey: {
          description: "Ireland",
          code: "IE",
        },
        XPT: {
          description: "Ireland",
          code: "IE",
        },
        ConcertAI: {
          description: "Ireland",
          code: "IE",
        },
        MDM: {
          description: "Ireland",
          code: "IE",
        },
      },
      {
        "Canonical Value": {
          description: "Iran, Islamic Republic of",
          code: "IR",
        },
        Onekey: {
          description: "Iran, Islamic Republic of",
          code: "IR",
        },
        XPT: {
          description: "Iran, Islamic Republic of",
          code: "IR",
        },
        ConcertAI: {
          description: "Iran, Islamic Republic of",
          code: "IR",
        },
        MDM: {
          description: "Iran, Islamic Republic of",
          code: "IR",
        },
      },
      {
        "Canonical Value": {
          description: "Iraq",
          code: "IQ",
        },
        Onekey: {
          description: "Iraq",
          code: "IQ",
        },
        XPT: {
          description: "Iraq",
          code: "IQ",
        },
        ConcertAI: {
          description: "Iraq",
          code: "IQ",
        },
        MDM: {
          description: "Iraq",
          code: "IQ",
        },
      },
      {
        "Canonical Value": {
          description: "Iceland",
          code: "IS",
        },
        Onekey: {
          description: "Iceland",
          code: "IS",
        },
        XPT: {
          description: "Iceland",
          code: "IS",
        },
        ConcertAI: {
          description: "Iceland",
          code: "IS",
        },
        MDM: {
          description: "Iceland",
          code: "IS",
        },
      },
      {
        "Canonical Value": {
          description: "Israel",
          code: "IL",
        },
        Onekey: {
          description: "Israel",
          code: "IL",
        },
        XPT: {
          description: "Israel",
          code: "IL",
        },
        ConcertAI: {
          description: "Israel",
          code: "IL",
        },
        MDM: {
          description: "Israel",
          code: "IL",
        },
      },
      {
        "Canonical Value": {
          description: "Italy",
          code: "IT",
        },
        Onekey: {
          description: "Italy",
          code: "IT",
        },
        XPT: {
          description: "Italy",
          code: "IT",
        },
        ConcertAI: {
          description: "Italy",
          code: "IT",
        },
        MDM: {
          description: "Italy",
          code: "IT",
        },
      },
      {
        "Canonical Value": {
          description: "Jamaica",
          code: "JM",
        },
        Onekey: {
          description: "Jamaica",
          code: "JM",
        },
        XPT: {
          description: "Jamaica",
          code: "JM",
        },
        ConcertAI: {
          description: "Jamaica",
          code: "JM",
        },
        MDM: {
          description: "Jamaica",
          code: "JM",
        },
      },
      {
        "Canonical Value": {
          description: "Jersey",
          code: "JE",
        },
        Onekey: {
          description: "Jersey",
          code: "JE",
        },
        XPT: {
          description: "Jersey",
          code: "JE",
        },
        ConcertAI: {
          description: "Jersey",
          code: "JE",
        },
        MDM: {
          description: "Jersey",
          code: "JE",
        },
      },
      {
        "Canonical Value": {
          description: "Jordan",
          code: "JO",
        },
        Onekey: {
          description: "Jordan",
          code: "JO",
        },
        XPT: {
          description: "Jordan",
          code: "JO",
        },
        ConcertAI: {
          description: "Jordan",
          code: "JO",
        },
        MDM: {
          description: "Jordan",
          code: "JO",
        },
      },
      {
        "Canonical Value": {
          description: "Japan",
          code: "JP",
        },
        Onekey: {
          description: "Japan",
          code: "JP",
        },
        XPT: {
          description: "Japan",
          code: "JP",
        },
        ConcertAI: {
          description: "Japan",
          code: "JP",
        },
        MDM: {
          description: "Japan",
          code: "JP",
        },
      },
      {
        "Canonical Value": {
          description: "Kazakhstan",
          code: "KZ",
        },
        Onekey: {
          description: "Kazakhstan",
          code: "KZ",
        },
        XPT: {
          description: "Kazakhstan",
          code: "KZ",
        },
        ConcertAI: {
          description: "Kazakhstan",
          code: "KZ",
        },
        MDM: {
          description: "Kazakhstan",
          code: "KZ",
        },
      },
      {
        "Canonical Value": {
          description: "Kenya",
          code: "KE",
        },
        Onekey: {
          description: "Kenya",
          code: "KE",
        },
        XPT: {
          description: "Kenya",
          code: "KE",
        },
        ConcertAI: {
          description: "Kenya",
          code: "KE",
        },
        MDM: {
          description: "Kenya",
          code: "KE",
        },
      },
      {
        "Canonical Value": {
          description: "Kyrgyzstan",
          code: "KG",
        },
        Onekey: {
          description: "Kyrgyzstan",
          code: "KG",
        },
        XPT: {
          description: "Kyrgyzstan",
          code: "KG",
        },
        ConcertAI: {
          description: "Kyrgyzstan",
          code: "KG",
        },
        MDM: {
          description: "Kyrgyzstan",
          code: "KG",
        },
      },
      {
        "Canonical Value": {
          description: "Cambodia",
          code: "KH",
        },
        Onekey: {
          description: "Cambodia",
          code: "KH",
        },
        XPT: {
          description: "Cambodia",
          code: "KH",
        },
        ConcertAI: {
          description: "Cambodia",
          code: "KH",
        },
        MDM: {
          description: "Cambodia",
          code: "KH",
        },
      },
      {
        "Canonical Value": {
          description: "Kiribati",
          code: "KI",
        },
        Onekey: {
          description: "Kiribati",
          code: "KI",
        },
        XPT: {
          description: "Kiribati",
          code: "KI",
        },
        ConcertAI: {
          description: "Kiribati",
          code: "KI",
        },
        MDM: {
          description: "Kiribati",
          code: "KI",
        },
      },
      {
        "Canonical Value": {
          description: "Saint Kitts and Nevis",
          code: "KN",
        },
        Onekey: {
          description: "Saint Kitts and Nevis",
          code: "KN",
        },
        XPT: {
          description: "Saint Kitts and Nevis",
          code: "KN",
        },
        ConcertAI: {
          description: "Saint Kitts and Nevis",
          code: "KN",
        },
        MDM: {
          description: "Saint Kitts and Nevis",
          code: "KN",
        },
      },
      {
        "Canonical Value": {
          description: "Korea, Republic of",
          code: "KR",
        },
        Onekey: {
          description: "Korea, Republic of",
          code: "KR",
        },
        XPT: {
          description: "Korea, Republic of",
          code: "KR",
        },
        ConcertAI: {
          description: "Korea, Republic of",
          code: "KR",
        },
        MDM: {
          description: "Korea, Republic of",
          code: "KR",
        },
      },
      {
        "Canonical Value": {
          description: "Kuwait",
          code: "KW",
        },
        Onekey: {
          description: "Kuwait",
          code: "KW",
        },
        XPT: {
          description: "Kuwait",
          code: "KW",
        },
        ConcertAI: {
          description: "Kuwait",
          code: "KW",
        },
        MDM: {
          description: "Kuwait",
          code: "KW",
        },
      },
      {
        "Canonical Value": {
          description: "Lao People's Democratic Republic",
          code: "LA",
        },
        Onekey: {
          description: "Lao People's Democratic Republic",
          code: "LA",
        },
        XPT: {
          description: "Lao People's Democratic Republic",
          code: "LA",
        },
        ConcertAI: {
          description: "Lao People's Democratic Republic",
          code: "LA",
        },
        MDM: {
          description: "Lao People's Democratic Republic",
          code: "LA",
        },
      },
      {
        "Canonical Value": {
          description: "Lebanon",
          code: "LB",
        },
        Onekey: {
          description: "Lebanon",
          code: "LB",
        },
        XPT: {
          description: "Lebanon",
          code: "LB",
        },
        ConcertAI: {
          description: "Lebanon",
          code: "LB",
        },
        MDM: {
          description: "Lebanon",
          code: "LB",
        },
      },
      {
        "Canonical Value": {
          description: "Liberia",
          code: "LR",
        },
        Onekey: {
          description: "Liberia",
          code: "LR",
        },
        XPT: {
          description: "Liberia",
          code: "LR",
        },
        ConcertAI: {
          description: "Liberia",
          code: "LR",
        },
        MDM: {
          description: "Liberia",
          code: "LR",
        },
      },
      {
        "Canonical Value": {
          description: "Libya",
          code: "LY",
        },
        Onekey: {
          description: "Libya",
          code: "LY",
        },
        XPT: {
          description: "Libya",
          code: "LY",
        },
        ConcertAI: {
          description: "Libya",
          code: "LY",
        },
        MDM: {
          description: "Libya",
          code: "LY",
        },
      },
      {
        "Canonical Value": {
          description: "Saint Lucia",
          code: "LC",
        },
        Onekey: {
          description: "Saint Lucia",
          code: "LC",
        },
        XPT: {
          description: "Saint Lucia",
          code: "LC",
        },
        ConcertAI: {
          description: "Saint Lucia",
          code: "LC",
        },
        MDM: {
          description: "Saint Lucia",
          code: "LC",
        },
      },
      {
        "Canonical Value": {
          description: "Liechtenstein",
          code: "LI",
        },
        Onekey: {
          description: "Liechtenstein",
          code: "LI",
        },
        XPT: {
          description: "Liechtenstein",
          code: "LI",
        },
        ConcertAI: {
          description: "Liechtenstein",
          code: "LI",
        },
        MDM: {
          description: "Liechtenstein",
          code: "LI",
        },
      },
      {
        "Canonical Value": {
          description: "Sri Lanka",
          code: "LK",
        },
        Onekey: {
          description: "Sri Lanka",
          code: "LK",
        },
        XPT: {
          description: "Sri Lanka",
          code: "LK",
        },
        ConcertAI: {
          description: "Sri Lanka",
          code: "LK",
        },
        MDM: {
          description: "Sri Lanka",
          code: "LK",
        },
      },
      {
        "Canonical Value": {
          description: "Lesotho",
          code: "LS",
        },
        Onekey: {
          description: "Lesotho",
          code: "LS",
        },
        XPT: {
          description: "Lesotho",
          code: "LS",
        },
        ConcertAI: {
          description: "Lesotho",
          code: "LS",
        },
        MDM: {
          description: "Lesotho",
          code: "LS",
        },
      },
      {
        "Canonical Value": {
          description: "Lithuania",
          code: "LT",
        },
        Onekey: {
          description: "Lithuania",
          code: "LT",
        },
        XPT: {
          description: "Lithuania",
          code: "LT",
        },
        ConcertAI: {
          description: "Lithuania",
          code: "LT",
        },
        MDM: {
          description: "Lithuania",
          code: "LT",
        },
      },
      {
        "Canonical Value": {
          description: "Luxembourg",
          code: "LU",
        },
        Onekey: {
          description: "Luxembourg",
          code: "LU",
        },
        XPT: {
          description: "Luxembourg",
          code: "LU",
        },
        ConcertAI: {
          description: "Luxembourg",
          code: "LU",
        },
        MDM: {
          description: "Luxembourg",
          code: "LU",
        },
      },
      {
        "Canonical Value": {
          description: "Latvia",
          code: "LV",
        },
        Onekey: {
          description: "Latvia",
          code: "LV",
        },
        XPT: {
          description: "Latvia",
          code: "LV",
        },
        ConcertAI: {
          description: "Latvia",
          code: "LV",
        },
        MDM: {
          description: "Latvia",
          code: "LV",
        },
      },
      {
        "Canonical Value": {
          description: "Macao",
          code: "MO",
        },
        Onekey: {
          description: "Macao",
          code: "MO",
        },
        XPT: {
          description: "Macao",
          code: "MO",
        },
        ConcertAI: {
          description: "Macao",
          code: "MO",
        },
        MDM: {
          description: "Macao",
          code: "MO",
        },
      },
      {
        "Canonical Value": {
          description: "Saint Martin (French part)",
          code: "MF",
        },
        Onekey: {
          description: "Saint Martin (French part)",
          code: "MF",
        },
        XPT: {
          description: "Saint Martin (French part)",
          code: "MF",
        },
        ConcertAI: {
          description: "Saint Martin (French part)",
          code: "MF",
        },
        MDM: {
          description: "Saint Martin (French part)",
          code: "MF",
        },
      },
      {
        "Canonical Value": {
          description: "Morocco",
          code: "MA",
        },
        Onekey: {
          description: "Morocco",
          code: "MA",
        },
        XPT: {
          description: "Morocco",
          code: "MA",
        },
        ConcertAI: {
          description: "Morocco",
          code: "MA",
        },
        MDM: {
          description: "Morocco",
          code: "MA",
        },
      },
      {
        "Canonical Value": {
          description: "Monaco",
          code: "MC",
        },
        Onekey: {
          description: "Monaco",
          code: "MC",
        },
        XPT: {
          description: "Monaco",
          code: "MC",
        },
        ConcertAI: {
          description: "Monaco",
          code: "MC",
        },
        MDM: {
          description: "Monaco",
          code: "MC",
        },
      },
      {
        "Canonical Value": {
          description: "Moldova, Republic of",
          code: "MD",
        },
        Onekey: {
          description: "Moldova, Republic of",
          code: "MD",
        },
        XPT: {
          description: "Moldova, Republic of",
          code: "MD",
        },
        ConcertAI: {
          description: "Moldova, Republic of",
          code: "MD",
        },
        MDM: {
          description: "Moldova, Republic of",
          code: "MD",
        },
      },
      {
        "Canonical Value": {
          description: "Madagascar",
          code: "MG",
        },
        Onekey: {
          description: "Madagascar",
          code: "MG",
        },
        XPT: {
          description: "Madagascar",
          code: "MG",
        },
        ConcertAI: {
          description: "Madagascar",
          code: "MG",
        },
        MDM: {
          description: "Madagascar",
          code: "MG",
        },
      },
      {
        "Canonical Value": {
          description: "Maldives",
          code: "MV",
        },
        Onekey: {
          description: "Maldives",
          code: "MV",
        },
        XPT: {
          description: "Maldives",
          code: "MV",
        },
        ConcertAI: {
          description: "Maldives",
          code: "MV",
        },
        MDM: {
          description: "Maldives",
          code: "MV",
        },
      },
      {
        "Canonical Value": {
          description: "Mexico",
          code: "MX",
        },
        Onekey: {
          description: "Mexico",
          code: "MX",
        },
        XPT: {
          description: "Mexico",
          code: "MX",
        },
        ConcertAI: {
          description: "Mexico",
          code: "MX",
        },
        MDM: {
          description: "Mexico",
          code: "MX",
        },
      },
      {
        "Canonical Value": {
          description: "Marshall Islands",
          code: "MH",
        },
        Onekey: {
          description: "Marshall Islands",
          code: "MH",
        },
        XPT: {
          description: "Marshall Islands",
          code: "MH",
        },
        ConcertAI: {
          description: "Marshall Islands",
          code: "MH",
        },
        MDM: {
          description: "Marshall Islands",
          code: "MH",
        },
      },
      {
        "Canonical Value": {
          description: "North Macedonia",
          code: "MK",
        },
        Onekey: {
          description: "North Macedonia",
          code: "MK",
        },
        XPT: {
          description: "North Macedonia",
          code: "MK",
        },
        ConcertAI: {
          description: "North Macedonia",
          code: "MK",
        },
        MDM: {
          description: "North Macedonia",
          code: "MK",
        },
      },
      {
        "Canonical Value": {
          description: "Mali",
          code: "ML",
        },
        Onekey: {
          description: "Mali",
          code: "ML",
        },
        XPT: {
          description: "Mali",
          code: "ML",
        },
        ConcertAI: {
          description: "Mali",
          code: "ML",
        },
        MDM: {
          description: "Mali",
          code: "ML",
        },
      },
      {
        "Canonical Value": {
          description: "Malta",
          code: "MT",
        },
        Onekey: {
          description: "Malta",
          code: "MT",
        },
        XPT: {
          description: "Malta",
          code: "MT",
        },
        ConcertAI: {
          description: "Malta",
          code: "MT",
        },
        MDM: {
          description: "Malta",
          code: "MT",
        },
      },
      {
        "Canonical Value": {
          description: "Myanmar",
          code: "MM",
        },
        Onekey: {
          description: "Myanmar",
          code: "MM",
        },
        XPT: {
          description: "Myanmar",
          code: "MM",
        },
        ConcertAI: {
          description: "Myanmar",
          code: "MM",
        },
        MDM: {
          description: "Myanmar",
          code: "MM",
        },
      },
      {
        "Canonical Value": {
          description: "Montenegro",
          code: "ME",
        },
        Onekey: {
          description: "Montenegro",
          code: "ME",
        },
        XPT: {
          description: "Montenegro",
          code: "ME",
        },
        ConcertAI: {
          description: "Montenegro",
          code: "ME",
        },
        MDM: {
          description: "Montenegro",
          code: "ME",
        },
      },
      {
        "Canonical Value": {
          description: "Mongolia",
          code: "MN",
        },
        Onekey: {
          description: "Mongolia",
          code: "MN",
        },
        XPT: {
          description: "Mongolia",
          code: "MN",
        },
        ConcertAI: {
          description: "Mongolia",
          code: "MN",
        },
        MDM: {
          description: "Mongolia",
          code: "MN",
        },
      },
      {
        "Canonical Value": {
          description: "Northern Mariana Islands",
          code: "MP",
        },
        Onekey: {
          description: "Northern Mariana Islands",
          code: "MP",
        },
        XPT: {
          description: "Northern Mariana Islands",
          code: "MP",
        },
        ConcertAI: {
          description: "Northern Mariana Islands",
          code: "MP",
        },
        MDM: {
          description: "Northern Mariana Islands",
          code: "MP",
        },
      },
      {
        "Canonical Value": {
          description: "Mozambique",
          code: "MZ",
        },
        Onekey: {
          description: "Mozambique",
          code: "MZ",
        },
        XPT: {
          description: "Mozambique",
          code: "MZ",
        },
        ConcertAI: {
          description: "Mozambique",
          code: "MZ",
        },
        MDM: {
          description: "Mozambique",
          code: "MZ",
        },
      },
      {
        "Canonical Value": {
          description: "Mauritania",
          code: "MR",
        },
        Onekey: {
          description: "Mauritania",
          code: "MR",
        },
        XPT: {
          description: "Mauritania",
          code: "MR",
        },
        ConcertAI: {
          description: "Mauritania",
          code: "MR",
        },
        MDM: {
          description: "Mauritania",
          code: "MR",
        },
      },
      {
        "Canonical Value": {
          description: "Montserrat",
          code: "MS",
        },
        Onekey: {
          description: "Montserrat",
          code: "MS",
        },
        XPT: {
          description: "Montserrat",
          code: "MS",
        },
        ConcertAI: {
          description: "Montserrat",
          code: "MS",
        },
        MDM: {
          description: "Montserrat",
          code: "MS",
        },
      },
      {
        "Canonical Value": {
          description: "Martinique",
          code: "MQ",
        },
        Onekey: {
          description: "Martinique",
          code: "MQ",
        },
        XPT: {
          description: "Martinique",
          code: "MQ",
        },
        ConcertAI: {
          description: "Martinique",
          code: "MQ",
        },
        MDM: {
          description: "Martinique",
          code: "MQ",
        },
      },
      {
        "Canonical Value": {
          description: "Mauritius",
          code: "MU",
        },
        Onekey: {
          description: "Mauritius",
          code: "MU",
        },
        XPT: {
          description: "Mauritius",
          code: "MU",
        },
        ConcertAI: {
          description: "Mauritius",
          code: "MU",
        },
        MDM: {
          description: "Mauritius",
          code: "MU",
        },
      },
      {
        "Canonical Value": {
          description: "Malawi",
          code: "MW",
        },
        Onekey: {
          description: "Malawi",
          code: "MW",
        },
        XPT: {
          description: "Malawi",
          code: "MW",
        },
        ConcertAI: {
          description: "Malawi",
          code: "MW",
        },
        MDM: {
          description: "Malawi",
          code: "MW",
        },
      },
      {
        "Canonical Value": {
          description: "Malaysia",
          code: "MY",
        },
        Onekey: {
          description: "Malaysia",
          code: "MY",
        },
        XPT: {
          description: "Malaysia",
          code: "MY",
        },
        ConcertAI: {
          description: "Malaysia",
          code: "MY",
        },
        MDM: {
          description: "Malaysia",
          code: "MY",
        },
      },
      {
        "Canonical Value": {
          description: "Mayotte",
          code: "YT",
        },
        Onekey: {
          description: "Mayotte",
          code: "YT",
        },
        XPT: {
          description: "Mayotte",
          code: "YT",
        },
        ConcertAI: {
          description: "Mayotte",
          code: "YT",
        },
        MDM: {
          description: "Mayotte",
          code: "YT",
        },
      },
      {
        "Canonical Value": {
          description: "Namibia",
          code: "NA",
        },
        Onekey: {
          description: "Namibia",
          code: "NA",
        },
        XPT: {
          description: "Namibia",
          code: "NA",
        },
        ConcertAI: {
          description: "Namibia",
          code: "NA",
        },
        MDM: {
          description: "Namibia",
          code: "NA",
        },
      },
      {
        "Canonical Value": {
          description: "New Caledonia",
          code: "NC",
        },
        Onekey: {
          description: "New Caledonia",
          code: "NC",
        },
        XPT: {
          description: "New Caledonia",
          code: "NC",
        },
        ConcertAI: {
          description: "New Caledonia",
          code: "NC",
        },
        MDM: {
          description: "New Caledonia",
          code: "NC",
        },
      },
      {
        "Canonical Value": {
          description: "Niger",
          code: "NE",
        },
        Onekey: {
          description: "Niger",
          code: "NE",
        },
        XPT: {
          description: "Niger",
          code: "NE",
        },
        ConcertAI: {
          description: "Niger",
          code: "NE",
        },
        MDM: {
          description: "Niger",
          code: "NE",
        },
      },
      {
        "Canonical Value": {
          description: "Norfolk Island",
          code: "NF",
        },
        Onekey: {
          description: "Norfolk Island",
          code: "NF",
        },
        XPT: {
          description: "Norfolk Island",
          code: "NF",
        },
        ConcertAI: {
          description: "Norfolk Island",
          code: "NF",
        },
        MDM: {
          description: "Norfolk Island",
          code: "NF",
        },
      },
      {
        "Canonical Value": {
          description: "Nigeria",
          code: "NG",
        },
        Onekey: {
          description: "Nigeria",
          code: "NG",
        },
        XPT: {
          description: "Nigeria",
          code: "NG",
        },
        ConcertAI: {
          description: "Nigeria",
          code: "NG",
        },
        MDM: {
          description: "Nigeria",
          code: "NG",
        },
      },
      {
        "Canonical Value": {
          description: "Nicaragua",
          code: "NI",
        },
        Onekey: {
          description: "Nicaragua",
          code: "NI",
        },
        XPT: {
          description: "Nicaragua",
          code: "NI",
        },
        ConcertAI: {
          description: "Nicaragua",
          code: "NI",
        },
        MDM: {
          description: "Nicaragua",
          code: "NI",
        },
      },
      {
        "Canonical Value": {
          description: "Niue",
          code: "NU",
        },
        Onekey: {
          description: "Niue",
          code: "NU",
        },
        XPT: {
          description: "Niue",
          code: "NU",
        },
        ConcertAI: {
          description: "Niue",
          code: "NU",
        },
        MDM: {
          description: "Niue",
          code: "NU",
        },
      },
      {
        "Canonical Value": {
          description: "Netherlands",
          code: "NL",
        },
        Onekey: {
          description: "Netherlands",
          code: "NL",
        },
        XPT: {
          description: "Netherlands",
          code: "NL",
        },
        ConcertAI: {
          description: "Netherlands",
          code: "NL",
        },
        MDM: {
          description: "Netherlands",
          code: "NL",
        },
      },
      {
        "Canonical Value": {
          description: "Norway",
          code: "NO",
        },
        Onekey: {
          description: "Norway",
          code: "NO",
        },
        XPT: {
          description: "Norway",
          code: "NO",
        },
        ConcertAI: {
          description: "Norway",
          code: "NO",
        },
        MDM: {
          description: "Norway",
          code: "NO",
        },
      },
      {
        "Canonical Value": {
          description: "Nepal",
          code: "NP",
        },
        Onekey: {
          description: "Nepal",
          code: "NP",
        },
        XPT: {
          description: "Nepal",
          code: "NP",
        },
        ConcertAI: {
          description: "Nepal",
          code: "NP",
        },
        MDM: {
          description: "Nepal",
          code: "NP",
        },
      },
      {
        "Canonical Value": {
          description: "Nauru",
          code: "NR",
        },
        Onekey: {
          description: "Nauru",
          code: "NR",
        },
        XPT: {
          description: "Nauru",
          code: "NR",
        },
        ConcertAI: {
          description: "Nauru",
          code: "NR",
        },
        MDM: {
          description: "Nauru",
          code: "NR",
        },
      },
      {
        "Canonical Value": {
          description: "New Zealand",
          code: "NZ",
        },
        Onekey: {
          description: "New Zealand",
          code: "NZ",
        },
        XPT: {
          description: "New Zealand",
          code: "NZ",
        },
        ConcertAI: {
          description: "New Zealand",
          code: "NZ",
        },
        MDM: {
          description: "New Zealand",
          code: "NZ",
        },
      },
      {
        "Canonical Value": {
          description: "Oman",
          code: "OM",
        },
        Onekey: {
          description: "Oman",
          code: "OM",
        },
        XPT: {
          description: "Oman",
          code: "OM",
        },
        ConcertAI: {
          description: "Oman",
          code: "OM",
        },
        MDM: {
          description: "Oman",
          code: "OM",
        },
      },
      {
        "Canonical Value": {
          description: "Pakistan",
          code: "PK",
        },
        Onekey: {
          description: "Pakistan",
          code: "PK",
        },
        XPT: {
          description: "Pakistan",
          code: "PK",
        },
        ConcertAI: {
          description: "Pakistan",
          code: "PK",
        },
        MDM: {
          description: "Pakistan",
          code: "PK",
        },
      },
      {
        "Canonical Value": {
          description: "Panama",
          code: "PA",
        },
        Onekey: {
          description: "Panama",
          code: "PA",
        },
        XPT: {
          description: "Panama",
          code: "PA",
        },
        ConcertAI: {
          description: "Panama",
          code: "PA",
        },
        MDM: {
          description: "Panama",
          code: "PA",
        },
      },
      {
        "Canonical Value": {
          description: "Pitcairn",
          code: "PN",
        },
        Onekey: {
          description: "Pitcairn",
          code: "PN",
        },
        XPT: {
          description: "Pitcairn",
          code: "PN",
        },
        ConcertAI: {
          description: "Pitcairn",
          code: "PN",
        },
        MDM: {
          description: "Pitcairn",
          code: "PN",
        },
      },
      {
        "Canonical Value": {
          description: "Peru",
          code: "PE",
        },
        Onekey: {
          description: "Peru",
          code: "PE",
        },
        XPT: {
          description: "Peru",
          code: "PE",
        },
        ConcertAI: {
          description: "Peru",
          code: "PE",
        },
        MDM: {
          description: "Peru",
          code: "PE",
        },
      },
      {
        "Canonical Value": {
          description: "Philippines",
          code: "PH",
        },
        Onekey: {
          description: "Philippines",
          code: "PH",
        },
        XPT: {
          description: "Philippines",
          code: "PH",
        },
        ConcertAI: {
          description: "Philippines",
          code: "PH",
        },
        MDM: {
          description: "Philippines",
          code: "PH",
        },
      },
      {
        "Canonical Value": {
          description: "Palau",
          code: "PW",
        },
        Onekey: {
          description: "Palau",
          code: "PW",
        },
        XPT: {
          description: "Palau",
          code: "PW",
        },
        ConcertAI: {
          description: "Palau",
          code: "PW",
        },
        MDM: {
          description: "Palau",
          code: "PW",
        },
      },
      {
        "Canonical Value": {
          description: "Papua New Guinea",
          code: "PG",
        },
        Onekey: {
          description: "Papua New Guinea",
          code: "PG",
        },
        XPT: {
          description: "Papua New Guinea",
          code: "PG",
        },
        ConcertAI: {
          description: "Papua New Guinea",
          code: "PG",
        },
        MDM: {
          description: "Papua New Guinea",
          code: "PG",
        },
      },
      {
        "Canonical Value": {
          description: "Poland",
          code: "PL",
        },
        Onekey: {
          description: "Poland",
          code: "PL",
        },
        XPT: {
          description: "Poland",
          code: "PL",
        },
        ConcertAI: {
          description: "Poland",
          code: "PL",
        },
        MDM: {
          description: "Poland",
          code: "PL",
        },
      },
      {
        "Canonical Value": {
          description: "Puerto Rico",
          code: "PR",
        },
        Onekey: {
          description: "Puerto Rico",
          code: "PR",
        },
        XPT: {
          description: "Puerto Rico",
          code: "PR",
        },
        ConcertAI: {
          description: "Puerto Rico",
          code: "PR",
        },
        MDM: {
          description: "Puerto Rico",
          code: "PR",
        },
      },
      {
        "Canonical Value": {
          description: "Korea, Democratic People's Republic of",
          code: "KP",
        },
        Onekey: {
          description: "Korea, Democratic People's Republic of",
          code: "KP",
        },
        XPT: {
          description: "Korea, Democratic People's Republic of",
          code: "KP",
        },
        ConcertAI: {
          description: "Korea, Democratic People's Republic of",
          code: "KP",
        },
        MDM: {
          description: "Korea, Democratic People's Republic of",
          code: "KP",
        },
      },
      {
        "Canonical Value": {
          description: "Portugal",
          code: "PT",
        },
        Onekey: {
          description: "Portugal",
          code: "PT",
        },
        XPT: {
          description: "Portugal",
          code: "PT",
        },
        ConcertAI: {
          description: "Portugal",
          code: "PT",
        },
        MDM: {
          description: "Portugal",
          code: "PT",
        },
      },
      {
        "Canonical Value": {
          description: "Paraguay",
          code: "PY",
        },
        Onekey: {
          description: "Paraguay",
          code: "PY",
        },
        XPT: {
          description: "Paraguay",
          code: "PY",
        },
        ConcertAI: {
          description: "Paraguay",
          code: "PY",
        },
        MDM: {
          description: "Paraguay",
          code: "PY",
        },
      },
      {
        "Canonical Value": {
          description: "Saudi Arabia",
          code: "SA",
        },
        Onekey: {
          description: "Saudi Arabia",
          code: "SA",
        },
        XPT: {
          description: "Saudi Arabia",
          code: "SA",
        },
        ConcertAI: {
          description: "Saudi Arabia",
          code: "SA",
        },
        MDM: {
          description: "Saudi Arabia",
          code: "SA",
        },
      },
      {
        "Canonical Value": {
          description: "Sudan",
          code: "SD",
        },
        Onekey: {
          description: "Sudan",
          code: "SD",
        },
        XPT: {
          description: "Sudan",
          code: "SD",
        },
        ConcertAI: {
          description: "Sudan",
          code: "SD",
        },
        MDM: {
          description: "Sudan",
          code: "SD",
        },
      },
      {
        "Canonical Value": {
          description: "Senegal",
          code: "SN",
        },
        Onekey: {
          description: "Senegal",
          code: "SN",
        },
        XPT: {
          description: "Senegal",
          code: "SN",
        },
        ConcertAI: {
          description: "Senegal",
          code: "SN",
        },
        MDM: {
          description: "Senegal",
          code: "SN",
        },
      },
      {
        "Canonical Value": {
          description: "Singapore",
          code: "SG",
        },
        Onekey: {
          description: "Singapore",
          code: "SG",
        },
        XPT: {
          description: "Singapore",
          code: "SG",
        },
        ConcertAI: {
          description: "Singapore",
          code: "SG",
        },
        MDM: {
          description: "Singapore",
          code: "SG",
        },
      },
      {
        "Canonical Value": {
          description: "South Georgia and the South Sandwich Islands",
          code: "GS",
        },
        Onekey: {
          description: "South Georgia and the South Sandwich Islands",
          code: "GS",
        },
        XPT: {
          description: "South Georgia and the South Sandwich Islands",
          code: "GS",
        },
        ConcertAI: {
          description: "South Georgia and the South Sandwich Islands",
          code: "GS",
        },
        MDM: {
          description: "South Georgia and the South Sandwich Islands",
          code: "GS",
        },
      },
      {
        "Canonical Value": {
          description: "Saint Helena, Ascension and Tristan da Cunha",
          code: "SH",
        },
        Onekey: {
          description: "Saint Helena, Ascension and Tristan da Cunha",
          code: "SH",
        },
        XPT: {
          description: "Saint Helena, Ascension and Tristan da Cunha",
          code: "SH",
        },
        ConcertAI: {
          description: "Saint Helena, Ascension and Tristan da Cunha",
          code: "SH",
        },
        MDM: {
          description: "Saint Helena, Ascension and Tristan da Cunha",
          code: "SH",
        },
      },
      {
        "Canonical Value": {
          description: "Svalbard and Jan Mayen",
          code: "SJ",
        },
        Onekey: {
          description: "Svalbard and Jan Mayen",
          code: "SJ",
        },
        XPT: {
          description: "Svalbard and Jan Mayen",
          code: "SJ",
        },
        ConcertAI: {
          description: "Svalbard and Jan Mayen",
          code: "SJ",
        },
        MDM: {
          description: "Svalbard and Jan Mayen",
          code: "SJ",
        },
      },
      {
        "Canonical Value": {
          description: "Solomon Islands",
          code: "SB",
        },
        Onekey: {
          description: "Solomon Islands",
          code: "SB",
        },
        XPT: {
          description: "Solomon Islands",
          code: "SB",
        },
        ConcertAI: {
          description: "Solomon Islands",
          code: "SB",
        },
        MDM: {
          description: "Solomon Islands",
          code: "SB",
        },
      },
      {
        "Canonical Value": {
          description: "Sierra Leone",
          code: "SL",
        },
        Onekey: {
          description: "Sierra Leone",
          code: "SL",
        },
        XPT: {
          description: "Sierra Leone",
          code: "SL",
        },
        ConcertAI: {
          description: "Sierra Leone",
          code: "SL",
        },
        MDM: {
          description: "Sierra Leone",
          code: "SL",
        },
      },
      {
        "Canonical Value": {
          description: "El Salvador",
          code: "SV",
        },
        Onekey: {
          description: "El Salvador",
          code: "SV",
        },
        XPT: {
          description: "El Salvador",
          code: "SV",
        },
        ConcertAI: {
          description: "El Salvador",
          code: "SV",
        },
        MDM: {
          description: "El Salvador",
          code: "SV",
        },
      },
      {
        "Canonical Value": {
          description: "San Marino",
          code: "SM",
        },
        Onekey: {
          description: "San Marino",
          code: "SM",
        },
        XPT: {
          description: "San Marino",
          code: "SM",
        },
        ConcertAI: {
          description: "San Marino",
          code: "SM",
        },
        MDM: {
          description: "San Marino",
          code: "SM",
        },
      },
      {
        "Canonical Value": {
          description: "Somalia",
          code: "SO",
        },
        Onekey: {
          description: "Somalia",
          code: "SO",
        },
        XPT: {
          description: "Somalia",
          code: "SO",
        },
        ConcertAI: {
          description: "Somalia",
          code: "SO",
        },
        MDM: {
          description: "Somalia",
          code: "SO",
        },
      },
      {
        "Canonical Value": {
          description: "Saint Pierre and Miquelon",
          code: "PM",
        },
        Onekey: {
          description: "Saint Pierre and Miquelon",
          code: "PM",
        },
        XPT: {
          description: "Saint Pierre and Miquelon",
          code: "PM",
        },
        ConcertAI: {
          description: "Saint Pierre and Miquelon",
          code: "PM",
        },
        MDM: {
          description: "Saint Pierre and Miquelon",
          code: "PM",
        },
      },
      {
        "Canonical Value": {
          description: "Serbia",
          code: "RS",
        },
        Onekey: {
          description: "Serbia",
          code: "RS",
        },
        XPT: {
          description: "Serbia",
          code: "RS",
        },
        ConcertAI: {
          description: "Serbia",
          code: "RS",
        },
        MDM: {
          description: "Serbia",
          code: "RS",
        },
      },
      {
        "Canonical Value": {
          description: "South Sudan",
          code: "SS",
        },
        Onekey: {
          description: "South Sudan",
          code: "SS",
        },
        XPT: {
          description: "South Sudan",
          code: "SS",
        },
        ConcertAI: {
          description: "South Sudan",
          code: "SS",
        },
        MDM: {
          description: "South Sudan",
          code: "SS",
        },
      },
      {
        "Canonical Value": {
          description: "Sao Tome and Principe",
          code: "ST",
        },
        Onekey: {
          description: "Sao Tome and Principe",
          code: "ST",
        },
        XPT: {
          description: "Sao Tome and Principe",
          code: "ST",
        },
        ConcertAI: {
          description: "Sao Tome and Principe",
          code: "ST",
        },
        MDM: {
          description: "Sao Tome and Principe",
          code: "ST",
        },
      },
      {
        "Canonical Value": {
          description: "Suriname",
          code: "SR",
        },
        Onekey: {
          description: "Suriname",
          code: "SR",
        },
        XPT: {
          description: "Suriname",
          code: "SR",
        },
        ConcertAI: {
          description: "Suriname",
          code: "SR",
        },
        MDM: {
          description: "Suriname",
          code: "SR",
        },
      },
      {
        "Canonical Value": {
          description: "Slovakia",
          code: "SK",
        },
        Onekey: {
          description: "Slovakia",
          code: "SK",
        },
        XPT: {
          description: "Slovakia",
          code: "SK",
        },
        ConcertAI: {
          description: "Slovakia",
          code: "SK",
        },
        MDM: {
          description: "Slovakia",
          code: "SK",
        },
      },
      {
        "Canonical Value": {
          description: "Slovenia",
          code: "SI",
        },
        Onekey: {
          description: "Slovenia",
          code: "SI",
        },
        XPT: {
          description: "Slovenia",
          code: "SI",
        },
        ConcertAI: {
          description: "Slovenia",
          code: "SI",
        },
        MDM: {
          description: "Slovenia",
          code: "SI",
        },
      },
      {
        "Canonical Value": {
          description: "Sweden",
          code: "SE",
        },
        Onekey: {
          description: "Sweden",
          code: "SE",
        },
        XPT: {
          description: "Sweden",
          code: "SE",
        },
        ConcertAI: {
          description: "Sweden",
          code: "SE",
        },
        MDM: {
          description: "Sweden",
          code: "SE",
        },
      },
      {
        "Canonical Value": {
          description: "Eswatini",
          code: "SZ",
        },
        Onekey: {
          description: "Eswatini",
          code: "SZ",
        },
        XPT: {
          description: "Eswatini",
          code: "SZ",
        },
        ConcertAI: {
          description: "Eswatini",
          code: "SZ",
        },
        MDM: {
          description: "Eswatini",
          code: "SZ",
        },
      },
      {
        "Canonical Value": {
          description: "Sint Maarten (Dutch part)",
          code: "SX",
        },
        Onekey: {
          description: "Sint Maarten (Dutch part)",
          code: "SX",
        },
        XPT: {
          description: "Sint Maarten (Dutch part)",
          code: "SX",
        },
        ConcertAI: {
          description: "Sint Maarten (Dutch part)",
          code: "SX",
        },
        MDM: {
          description: "Sint Maarten (Dutch part)",
          code: "SX",
        },
      },
      {
        "Canonical Value": {
          description: "Seychelles",
          code: "SC",
        },
        Onekey: {
          description: "Seychelles",
          code: "SC",
        },
        XPT: {
          description: "Seychelles",
          code: "SC",
        },
        ConcertAI: {
          description: "Seychelles",
          code: "SC",
        },
        MDM: {
          description: "Seychelles",
          code: "SC",
        },
      },
      {
        "Canonical Value": {
          description: "Syrian Arab Republic",
          code: "SY",
        },
        Onekey: {
          description: "Syrian Arab Republic",
          code: "SY",
        },
        XPT: {
          description: "Syrian Arab Republic",
          code: "SY",
        },
        ConcertAI: {
          description: "Syrian Arab Republic",
          code: "SY",
        },
        MDM: {
          description: "Syrian Arab Republic",
          code: "SY",
        },
      },
      {
        "Canonical Value": {
          description: "Turks and Caicos Islands",
          code: "TC",
        },
        Onekey: {
          description: "Turks and Caicos Islands",
          code: "TC",
        },
        XPT: {
          description: "Turks and Caicos Islands",
          code: "TC",
        },
        ConcertAI: {
          description: "Turks and Caicos Islands",
          code: "TC",
        },
        MDM: {
          description: "Turks and Caicos Islands",
          code: "TC",
        },
      },
      {
        "Canonical Value": {
          description: "Chad",
          code: "TD",
        },
        Onekey: {
          description: "Chad",
          code: "TD",
        },
        XPT: {
          description: "Chad",
          code: "TD",
        },
        ConcertAI: {
          description: "Chad",
          code: "TD",
        },
        MDM: {
          description: "Chad",
          code: "TD",
        },
      },
      {
        "Canonical Value": {
          description: "Togo",
          code: "TG",
        },
        Onekey: {
          description: "Togo",
          code: "TG",
        },
        XPT: {
          description: "Togo",
          code: "TG",
        },
        ConcertAI: {
          description: "Togo",
          code: "TG",
        },
        MDM: {
          description: "Togo",
          code: "TG",
        },
      },
      {
        "Canonical Value": {
          description: "Thailand",
          code: "TH",
        },
        Onekey: {
          description: "Thailand",
          code: "TH",
        },
        XPT: {
          description: "Thailand",
          code: "TH",
        },
        ConcertAI: {
          description: "Thailand",
          code: "TH",
        },
        MDM: {
          description: "Thailand",
          code: "TH",
        },
      },
      {
        "Canonical Value": {
          description: "Tajikistan",
          code: "TJ",
        },
        Onekey: {
          description: "Tajikistan",
          code: "TJ",
        },
        XPT: {
          description: "Tajikistan",
          code: "TJ",
        },
        ConcertAI: {
          description: "Tajikistan",
          code: "TJ",
        },
        MDM: {
          description: "Tajikistan",
          code: "TJ",
        },
      },
      {
        "Canonical Value": {
          description: "Tokelau",
          code: "TK",
        },
        Onekey: {
          description: "Tokelau",
          code: "TK",
        },
        XPT: {
          description: "Tokelau",
          code: "TK",
        },
        ConcertAI: {
          description: "Tokelau",
          code: "TK",
        },
        MDM: {
          description: "Tokelau",
          code: "TK",
        },
      },
      {
        "Canonical Value": {
          description: "Turkmenistan",
          code: "TM",
        },
        Onekey: {
          description: "Turkmenistan",
          code: "TM",
        },
        XPT: {
          description: "Turkmenistan",
          code: "TM",
        },
        ConcertAI: {
          description: "Turkmenistan",
          code: "TM",
        },
        MDM: {
          description: "Turkmenistan",
          code: "TM",
        },
      },
      {
        "Canonical Value": {
          description: "Timor-Leste",
          code: "TL",
        },
        Onekey: {
          description: "Timor-Leste",
          code: "TL",
        },
        XPT: {
          description: "Timor-Leste",
          code: "TL",
        },
        ConcertAI: {
          description: "Timor-Leste",
          code: "TL",
        },
        MDM: {
          description: "Timor-Leste",
          code: "TL",
        },
      },
      {
        "Canonical Value": {
          description: "Tonga",
          code: "TO",
        },
        Onekey: {
          description: "Tonga",
          code: "TO",
        },
        XPT: {
          description: "Tonga",
          code: "TO",
        },
        ConcertAI: {
          description: "Tonga",
          code: "TO",
        },
        MDM: {
          description: "Tonga",
          code: "TO",
        },
      },
      {
        "Canonical Value": {
          description: "Trinidad and Tobago",
          code: "TT",
        },
        Onekey: {
          description: "Trinidad and Tobago",
          code: "TT",
        },
        XPT: {
          description: "Trinidad and Tobago",
          code: "TT",
        },
        ConcertAI: {
          description: "Trinidad and Tobago",
          code: "TT",
        },
        MDM: {
          description: "Trinidad and Tobago",
          code: "TT",
        },
      },
      {
        "Canonical Value": {
          description: "Tunisia",
          code: "TN",
        },
        Onekey: {
          description: "Tunisia",
          code: "TN",
        },
        XPT: {
          description: "Tunisia",
          code: "TN",
        },
        ConcertAI: {
          description: "Tunisia",
          code: "TN",
        },
        MDM: {
          description: "Tunisia",
          code: "TN",
        },
      },
      {
        "Canonical Value": {
          description: "Turkey",
          code: "TR",
        },
        Onekey: {
          description: "Turkey",
          code: "TR",
        },
        XPT: {
          description: "Turkey",
          code: "TR",
        },
        ConcertAI: {
          description: "Turkey",
          code: "TR",
        },
        MDM: {
          description: "Turkey",
          code: "TR",
        },
      },
      {
        "Canonical Value": {
          description: "Tuvalu",
          code: "TV",
        },
        Onekey: {
          description: "Tuvalu",
          code: "TV",
        },
        XPT: {
          description: "Tuvalu",
          code: "TV",
        },
        ConcertAI: {
          description: "Tuvalu",
          code: "TV",
        },
        MDM: {
          description: "Tuvalu",
          code: "TV",
        },
      },
      {
        "Canonical Value": {
          description: "Taiwan, Province of China",
          code: "TW",
        },
        Onekey: {
          description: "Taiwan, Province of China",
          code: "TW",
        },
        XPT: {
          description: "Taiwan, Province of China",
          code: "TW",
        },
        ConcertAI: {
          description: "Taiwan, Province of China",
          code: "TW",
        },
        MDM: {
          description: "Taiwan, Province of China",
          code: "TW",
        },
      },
      {
        "Canonical Value": {
          description: "Tanzania, United Republic of",
          code: "TZ",
        },
        Onekey: {
          description: "Tanzania, United Republic of",
          code: "TZ",
        },
        XPT: {
          description: "Tanzania, United Republic of",
          code: "TZ",
        },
        ConcertAI: {
          description: "Tanzania, United Republic of",
          code: "TZ",
        },
        MDM: {
          description: "Tanzania, United Republic of",
          code: "TZ",
        },
      },
      {
        "Canonical Value": { description: "Uganda", code: "UG" },
        Onekey: { description: "Uganda", code: "UG" },
        XPT: { description: "Uganda", code: "UG" },
        ConcertAI: { description: "Uganda", code: "UG" },
        MDM: { description: "Uganda", code: "UG" },
      },
      {
        "Canonical Value": { description: "Ukraine", code: "UA" },
        Onekey: { description: "Ukraine", code: "UA" },
        XPT: { description: "Ukraine", code: "UA" },
        ConcertAI: { description: "Ukraine", code: "UA" },
        MDM: { description: "Ukraine", code: "UA" },
      },
      {
        "Canonical Value": {
          description: "United States Minor Outlying Islands",
          code: "UM",
        },
        Onekey: {
          description: "United States Minor Outlying Islands",
          code: "UM",
        },
        XPT: {
          description: "United States Minor Outlying Islands",
          code: "UM",
        },
        ConcertAI: {
          description: "United States Minor Outlying Islands",
          code: "UM",
        },
        MDM: {
          description: "United States Minor Outlying Islands",
          code: "UM",
        },
      },
      {
        "Canonical Value": { description: "Uruguay", code: "UY" },
        Onekey: { description: "Uruguay", code: "UY" },
        XPT: { description: "Uruguay", code: "UY" },
        ConcertAI: { description: "Uruguay", code: "UY" },
        MDM: { description: "Uruguay", code: "UY" },
      },
      {
        "Canonical Value": { description: "United States", code: "US" },
        Onekey: { description: "United States", code: "US" },
        XPT: { description: "United States", code: "US" },
        ConcertAI: { description: "United States", code: "US" },
        MDM: { description: "United States", code: "US" },
      },
      {
        "Canonical Value": { description: "Uzbekistan", code: "UZ" },
        Onekey: { description: "Uzbekistan", code: "UZ" },
        XPT: { description: "Uzbekistan", code: "UZ" },
        ConcertAI: { description: "Uzbekistan", code: "UZ" },
        MDM: { description: "Uzbekistan", code: "UZ" },
      },
      {
        "Canonical Value": {
          description: "Holy See (Vatican City State)",
          code: "VA",
        },
        Onekey: {
          description: "Holy See (Vatican City State)",
          code: "VA",
        },
        XPT: { description: "Holy See (Vatican City State)", code: "VA" },
        ConcertAI: {
          description: "Holy See (Vatican City State)",
          code: "VA",
        },
        MDM: { description: "Holy See (Vatican City State)", code: "VA" },
      },
      {
        "Canonical Value": {
          description: "Saint Vincent and the Grenadines",
          code: "VC",
        },
        Onekey: {
          description: "Saint Vincent and the Grenadines",
          code: "VC",
        },
        XPT: {
          description: "Saint Vincent and the Grenadines",
          code: "VC",
        },
        ConcertAI: {
          description: "Saint Vincent and the Grenadines",
          code: "VC",
        },
        MDM: {
          description: "Saint Vincent and the Grenadines",
          code: "VC",
        },
      },
      {
        "Canonical Value": {
          description: "Venezuela, Bolivarian Republic of",
          code: "VE",
        },
        Onekey: {
          description: "Venezuela, Bolivarian Republic of",
          code: "VE",
        },
        XPT: {
          description: "Venezuela, Bolivarian Republic of",
          code: "VE",
        },
        ConcertAI: {
          description: "Venezuela, Bolivarian Republic of",
          code: "VE",
        },
        MDM: {
          description: "Venezuela, Bolivarian Republic of",
          code: "VE",
        },
      },
      {
        "Canonical Value": {
          description: "Virgin Islands, British",
          code: "VG",
        },
        Onekey: { description: "Virgin Islands, British", code: "VG" },
        XPT: { description: "Virgin Islands, British", code: "VG" },
        ConcertAI: { description: "Virgin Islands, British", code: "VG" },
        MDM: { description: "Virgin Islands, British", code: "VG" },
      },
      {
        "Canonical Value": {
          description: "Virgin Islands, U.S.",
          code: "VI",
        },
        Onekey: { description: "Virgin Islands, U.S.", code: "VI" },
        XPT: { description: "Virgin Islands, U.S.", code: "VI" },
        ConcertAI: { description: "Virgin Islands, U.S.", code: "VI" },
        MDM: { description: "Virgin Islands, U.S.", code: "VI" },
      },
      {
        "Canonical Value": { description: "Viet Nam", code: "VN" },
        Onekey: { description: "Viet Nam", code: "VN" },
        XPT: { description: "Viet Nam", code: "VN" },
        ConcertAI: { description: "Viet Nam", code: "VN" },
        MDM: { description: "Viet Nam", code: "VN" },
      },
      {
        "Canonical Value": { description: "Vanuatu", code: "VU" },
        Onekey: { description: "Vanuatu", code: "VU" },
        XPT: { description: "Vanuatu", code: "VU" },
        ConcertAI: { description: "Vanuatu", code: "VU" },
        MDM: { description: "Vanuatu", code: "VU" },
      },
      {
        "Canonical Value": {
          description: "Wallis and Futuna",
          code: "WF",
        },
        Onekey: { description: "Wallis and Futuna", code: "WF" },
        XPT: { description: "Wallis and Futuna", code: "WF" },
        ConcertAI: { description: "Wallis and Futuna", code: "WF" },
        MDM: { description: "Wallis and Futuna", code: "WF" },
      },
      {
        "Canonical Value": { description: "Samoa", code: "WS" },
        Onekey: { description: "Samoa", code: "WS" },
        XPT: { description: "Samoa", code: "WS" },
        ConcertAI: { description: "Samoa", code: "WS" },
        MDM: { description: "Samoa", code: "WS" },
      },
      {
        "Canonical Value": { description: "Yemen", code: "YE" },
        Onekey: { description: "Yemen", code: "YE" },
        XPT: { description: "Yemen", code: "YE" },
        ConcertAI: { description: "Yemen", code: "YE" },
        MDM: { description: "Yemen", code: "YE" },
      },
      {
        "Canonical Value": { description: "South Africa", code: "ZA" },
        Onekey: { description: "South Africa", code: "ZA" },
        XPT: { description: "South Africa", code: "ZA" },
        ConcertAI: { description: "South Africa", code: "ZA" },
        MDM: { description: "South Africa", code: "ZA" },
      },
      {
        "Canonical Value": { description: "Zambia", code: "ZM" },
        Onekey: { description: "Zambia", code: "ZM" },
        XPT: { description: "Zambia", code: "ZM" },
        ConcertAI: { description: "Zambia", code: "ZM" },
        MDM: { description: "Zambia", code: "ZM" },
      },
      {
        "Canonical Value": { description: "Zimbabwe", code: "ZW" },
        Onekey: { description: "Zimbabwe", code: "ZW" },
        XPT: { description: "Zimbabwe", code: "ZW" },
        ConcertAI: { description: "Zimbabwe", code: "ZW" },
        MDM: { description: "Zimbabwe", code: "ZW" },
      },
    ],
  },
  {
    name: "professions",
    startdate: "2022-09-05",
    enddate: "2022-09-20",
    sourcevalues: 23,
    unmappedvalues: 4,
    tableData: [
      {
        "Canonical Value": { code: "MD", description: "Medical Doctor" },

        Onekey: { code: "MD", description: "Medical Doctor" },
        ConcertAI: { code: "MD", description: "Medical Doctor" },
        XPT: { code: "MD", description: "Medical Doctor" },
        MDM: { code: "MD", description: "Medical Doctor" },
      },
      {
        "Canonical Value": {
          code: "DO",
          description: "Doctor of Osteopathy",
        },

        Onekey: { code: "DO", description: "Doctor of Osteopathy" },
        ConcertAI: { code: "DO", description: "Doctor of Osteopathy" },
        XPT: { code: "DO", description: "Doctor of Osteopathy" },
        MDM: { code: "DO", description: "Doctor of Osteopathy" },
      },
      {
        "Canonical Value": {
          code: "NP",
          description: "Nurse Practitioner",
        },

        Onekey: { code: "NP", description: "Nurse Practitioner" },
        ConcertAI: { code: "NP", description: "Nurse Practitioner" },
        XPT: { code: "NP", description: "Nurse Practitioner" },
        MDM: { code: "NP", description: "Nurse Practitioner" },
      },
      {
        "Canonical Value": {
          code: "PA",
          description: "Physician Assistant",
        },

        Onekey: { code: "PA", description: "Physician Assistant" },
        ConcertAI: { code: "PA", description: "Physician Assistant" },
        XPT: { code: "PA", description: "Physician Assistant" },
        MDM: { code: "PA", description: "Physician Assistant" },
      },
      {
        "Canonical Value": {
          code: "RN",
          description: "Registered Nurse",
        },

        Onekey: { code: "RN", description: "Registered Nurse" },
        ConcertAI: { code: "RN", description: "Registered Nurse" },
        XPT: { code: "RN", description: "Registered Nurse" },
        MDM: { code: "RN", description: "Registered Nurse" },
      },
      {
        "Canonical Value": { code: "PH", description: "Pharmacist" },

        Onekey: { code: "PH", description: "Pharmacist" },
        ConcertAI: { code: "PH", description: "Pharmacist" },
        XPT: { code: "PH", description: "Pharmacist" },
        MDM: { code: "PH", description: "Pharmacist" },
      },
      {
        "Canonical Value": { code: "DDS", description: "Dentist" },

        Onekey: { code: "DDS", description: "Dentist" },
        ConcertAI: { code: "DDS", description: "Dentist" },
        XPT: { code: "DDS", description: "Dentist" },
        MDM: { code: "DDS", description: "Dentist" },
      },
      {
        "Canonical Value": {
          code: "DMD",
          description: "Doctor of Dental Medicine",
        },

        Onekey: { code: "DMD", description: "Doctor of Dental Medicine" },
        ConcertAI: {
          code: "DMD",
          description: "Doctor of Dental Medicine",
        },
        XPT: { code: "DMD", description: "Doctor of Dental Medicine" },
        MDM: { code: "DMD", description: "Doctor of Dental Medicine" },
      },
      {
        "Canonical Value": { code: "DVM", description: "Veterinarian" },

        Onekey: { code: "DVM", description: "Veterinarian" },
        ConcertAI: { code: "DVM", description: "Veterinarian" },
        XPT: { code: "DVM", description: "Veterinarian" },
        MDM: { code: "DVM", description: "Veterinarian" },
      },
      {
        "Canonical Value": {
          code: "OD",
          description: "Doctor of Optometry",
        },

        Onekey: { code: "OD", description: "Doctor of Optometry" },
        ConcertAI: { code: "OD", description: "Doctor of Optometry" },
        XPT: { code: "OD", description: "Doctor of Optometry" },
        MDM: { code: "OD", description: "Doctor of Optometry" },
      },
      {
        "Canonical Value": {
          code: "CNM",
          description: "Certified Nurse Midwife",
        },

        Onekey: { code: "CNM", description: "Certified Nurse Midwife" },
        ConcertAI: {
          code: "CNM",
          description: "Certified Nurse Midwife",
        },
        XPT: { code: "CNM", description: "Certified Nurse Midwife" },
        MDM: { code: "CNM", description: "Certified Nurse Midwife" },
      },
      {
        "Canonical Value": {
          code: "DC",
          description: "Doctor of Chiropractic",
        },

        Onekey: { code: "DC", description: "Doctor of Chiropractic" },
        ConcertAI: { code: "DC", description: "Doctor of Chiropractic" },
        XPT: { code: "DC", description: "Doctor of Chiropractic" },
        MDM: { code: "DC", description: "Doctor of Chiropractic" },
      },
      {
        "Canonical Value": {
          code: "PT",
          description: "Physical Therapist",
        },

        Onekey: { code: "PT", description: "Physical Therapist" },
        ConcertAI: { code: "PT", description: "Physical Therapist" },
        XPT: { code: "PT", description: "Physical Therapist" },
        MDM: { code: "PT", description: "Physical Therapist" },
      },
      {
        "Canonical Value": {
          code: "OT",
          description: "Occupational Therapist",
        },

        Onekey: { code: "OT", description: "Occupational Therapist" },
        ConcertAI: { code: "OT", description: "Occupational Therapist" },
        XPT: { code: "OT", description: "Occupational Therapist" },
        MDM: { code: "OT", description: "Occupational Therapist" },
      },
      {
        "Canonical Value": {
          code: "SLP",
          description: "Speech-Language Pathologist",
        },

        Onekey: {
          code: "SLP",
          description: "Speech-Language Pathologist",
        },
        ConcertAI: {
          code: "SLP",
          description: "Speech-Language Pathologist",
        },
        XPT: { code: "SLP", description: "Speech-Language Pathologist" },
        MDM: { code: "SLP", description: "Speech-Language Pathologist" },
      },
      {
        "Canonical Value": {
          code: "RD",
          description: "Registered Dietitian",
        },

        Onekey: { code: "RD", description: "Registered Dietitian" },
        ConcertAI: { code: "RD", description: "Registered Dietitian" },
        XPT: { code: "RD", description: "Registered Dietitian" },
        MDM: { code: "RD", description: "Registered Dietitian" },
      },
      {
        "Canonical Value": {
          code: "PHD",
          description: "Doctor of Philosophy (Medical/Scientific field)",
        },

        Onekey: {
          code: "PHD",
          description: "Doctor of Philosophy (Medical/Scientific field)",
        },
        ConcertAI: {
          code: "PHD",
          description: "Doctor of Philosophy (Medical/Scientific field)",
        },
        XPT: {
          code: "PHD",
          description: "Doctor of Philosophy (Medical/Scientific field)",
        },
        MDM: {
          code: "PHD",
          description: "Doctor of Philosophy (Medical/Scientific field)",
        },
      },
      {
        "Canonical Value": {
          code: "PSY",
          description: "Clinical Psychologist",
        },

        Onekey: { code: "PSY", description: "Clinical Psychologist" },
        ConcertAI: { code: "PSY", description: "Clinical Psychologist" },
        XPT: { code: "PSY", description: "Clinical Psychologist" },
        MDM: { code: "PSY", description: "Clinical Psychologist" },
      },
      {
        "Canonical Value": { code: "SW", description: "Social Worker" },

        Onekey: { code: "SW", description: "Social Worker" },
        ConcertAI: { code: "SW", description: "Social Worker" },
        XPT: { code: "SW", description: "Social Worker" },
        MDM: { code: "SW", description: "Social Worker" },
      },
      {
        "Canonical Value": {
          code: "LMFT",
          description: "Licensed Marriage and Family Therapist",
        },

        Onekey: {
          code: "LMFT",
          description: "Licensed Marriage and Family Therapist",
        },
        ConcertAI: {
          code: "LMFT",
          description: "Licensed Marriage and Family Therapist",
        },
        XPT: {
          code: "LMFT",
          description: "Licensed Marriage and Family Therapist",
        },
        MDM: {
          code: "LMFT",
          description: "Licensed Marriage and Family Therapist",
        },
      },
      {
        "Canonical Value": {
          code: "LCSW",
          description: "Licensed Clinical Social Worker",
        },

        Onekey: {
          code: "LCSW",
          description: "Licensed Clinical Social Worker",
        },
        ConcertAI: {
          code: "LCSW",
          description: "Licensed Clinical Social Worker",
        },
        XPT: {
          code: "LCSW",
          description: "Licensed Clinical Social Worker",
        },
        MDM: {
          code: "LCSW",
          description: "Licensed Clinical Social Worker",
        },
      },
      {
        "Canonical Value": {
          code: "LVN",
          description: "Licensed Vocational Nurse",
        },

        Onekey: { code: "LVN", description: "Licensed Vocational Nurse" },
        ConcertAI: {
          code: "LVN",
          description: "Licensed Vocational Nurse",
        },
        XPT: { code: "LVN", description: "Licensed Vocational Nurse" },
        MDM: { code: "LVN", description: "Licensed Vocational Nurse" },
      },
      {
        "Canonical Value": {
          code: "LPN",
          description: "Licensed Practical Nurse",
        },

        Onekey: { code: "LPN", description: "Licensed Practical Nurse" },
        ConcertAI: {
          code: "LPN",
          description: "Licensed Practical Nurse",
        },
        XPT: { code: "LPN", description: "Licensed Practical Nurse" },
        MDM: { code: "LPN", description: "Licensed Practical Nurse" },
      },
    ],
  },
  {
    name: "state",
    startdate: "2022-09-05",
    enddate: "2022-09-20",
    sourcevalues: 51,
    unmappedvalues: 4,
    tableData: [
      {
        "Canonical Value": {
          description: "Alabama",
          code: "AL",
        },
        Onekey: {
          description: "Alabama",
          code: "AL",
        },
        ConcertAI: {
          description: "Alabama",
          code: "AL",
        },
        XPT: {
          description: "Alabama",
          code: "AL",
        },
        MDM: {
          description: "Alabama",
          code: "AL",
        },
      },
      {
        "Canonical Value": {
          description: "Alaska",
          code: "AK",
        },
        Onekey: {
          description: "Alaska",
          code: "AK",
        },
        ConcertAI: {
          description: "Alaska",
          code: "AK",
        },
        XPT: {
          description: "Alaska",
          code: "AK",
        },
        MDM: {
          description: "Alaska",
          code: "AK",
        },
      },
      {
        "Canonical Value": {
          description: "Arizona",
          code: "AZ",
        },
        Onekey: {
          description: "Arizona",
          code: "AZ",
        },
        ConcertAI: {
          description: "Arizona",
          code: "AZ",
        },
        XPT: {
          description: "Arizona",
          code: "AZ",
        },
        MDM: {
          description: "Arizona",
          code: "AZ",
        },
      },
      {
        "Canonical Value": {
          description: "Arkansas",
          code: "AR",
        },
        Onekey: {
          description: "Arkansas",
          code: "AR",
        },
        ConcertAI: {
          description: "Arkansas",
          code: "AR",
        },
        XPT: {
          description: "Arkansas",
          code: "AR",
        },
        MDM: {
          description: "Arkansas",
          code: "AR",
        },
      },
      {
        "Canonical Value": {
          description: "California",
          code: "CA",
        },
        Onekey: {
          description: "California",
          code: "CA",
        },
        ConcertAI: {
          description: "California",
          code: "CA",
        },
        XPT: {
          description: "California",
          code: "CA",
        },
        MDM: {
          description: "California",
          code: "CA",
        },
      },
      {
        "Canonical Value": {
          description: "California",
          code: "CA",
        },
        Onekey: {
          description: "Colorado",
          code: "CO",
        },
        ConcertAI: {
          description: "Colorado",
          code: "CO",
        },
        XPT: {
          description: "Colorado",
          code: "CO",
        },
        MDM: {
          description: "Colorado",
          code: "CO",
        },
      },
      {
        "Canonical Value": {
          description: "Connecticut",
          code: "CT",
        },
        Onekey: {
          description: "Connecticut",
          code: "CT",
        },
        ConcertAI: {
          description: "Connecticut",
          code: "CT",
        },
        XPT: {
          description: "Connecticut",
          code: "CT",
        },
        MDM: {
          description: "Connecticut",
          code: "CT",
        },
      },
      {
        "Canonical Value": {
          description: "Delaware",
          code: "DE",
        },
        Onekey: {
          description: "Delaware",
          code: "DE",
        },
        ConcertAI: {
          description: "Delaware",
          code: "DE",
        },
        XPT: {
          description: "Delaware",
          code: "DE",
        },
        MDM: {
          description: "Delaware",
          code: "DE",
        },
      },
      {
        "Canonical Value": {
          description: "District of Columbia",
          code: "DC",
        },
        Onekey: {
          description: "District of Columbia",
          code: "DC",
        },
        ConcertAI: {
          description: "District of Columbia",
          code: "DC",
        },
        XPT: {
          description: "District of Columbia",
          code: "DC",
        },
        MDM: {
          description: "District of Columbia",
          code: "DC",
        },
      },
      {
        "Canonical Value": {
          description: "Florida",
          code: "FL",
        },
        Onekey: {
          description: "Florida",
          code: "FL",
        },
        ConcertAI: {
          description: "Florida",
          code: "FL",
        },
        XPT: {
          description: "Florida",
          code: "FL",
        },
        MDM: {
          description: "Florida",
          code: "FL",
        },
      },
      {
        "Canonical Value": {
          description: "Georgia",
          code: "GA",
        },
        Onekey: {
          description: "Georgia",
          code: "GA",
        },
        ConcertAI: {
          description: "Georgia",
          code: "GA",
        },
        XPT: {
          description: "Georgia",
          code: "GA",
        },
        MDM: {
          description: "Georgia",
          code: "GA",
        },
      },
      {
        "Canonical Value": {
          description: "Hawaii",
          code: "HI",
        },
        Onekey: {
          description: "Hawaii",
          code: "HI",
        },
        ConcertAI: {
          description: "Hawaii",
          code: "HI",
        },
        XPT: {
          description: "Hawaii",
          code: "HI",
        },
        MDM: {
          description: "Hawaii",
          code: "HI",
        },
      },
      {
        "Canonical Value": {
          description: "Idaho",
          code: "ID",
        },
        Onekey: {
          description: "Idaho",
          code: "ID",
        },
        ConcertAI: {
          description: "Idaho",
          code: "ID",
        },
        XPT: {
          description: "Idaho",
          code: "ID",
        },

        MDM: {
          description: "Idaho",
          code: "ID",
        },
      },
      {
        "Canonical Value": {
          description: "Illinois",
          code: "IL",
        },
        Onekey: {
          description: "Illinois",
          code: "IL",
        },
        ConcertAI: {
          description: "Illinois",
          code: "IL",
        },
        XPT: {
          description: "Illinois",
          code: "IL",
        },
        MDM: {
          description: "Illinois",
          code: "IL",
        },
      },
      {
        "Canonical Value": {
          description: "Indiana",
          code: "IN",
        },
        Onekey: {
          description: "Indiana",
          code: "IN",
        },
        ConcertAI: {
          description: "Indiana",
          code: "IN",
        },
        XPT: {
          description: "Indiana",
          code: "IN",
        },
        MDM: {
          description: "Indiana",
          code: "IN",
        },
      },
      {
        "Canonical Value": {
          description: "Iowa",
          code: "IA",
        },
        Onekey: {
          description: "Iowa",
          code: "IA",
        },
        ConcertAI: {
          description: "Iowa",
          code: "IA",
        },
        XPT: {
          description: "Iowa",
          code: "IA",
        },
        MDM: {
          description: "Iowa",
          code: "IA",
        },
      },
      {
        "Canonical Value": {
          description: "Kansas",
          code: "KS",
        },
        Onekey: {
          description: "Kansas",
          code: "KS",
        },
        ConcertAI: {
          description: "Kansas",
          code: "KS",
        },
        XPT: {
          description: "Kansas",
          code: "KS",
        },
        MDM: {
          description: "Kansas",
          code: "KS",
        },
      },
      {
        "Canonical Value": {
          description: "Kentucky",
          code: "KY",
        },
        Onekey: {
          description: "Kentucky",
          code: "KY",
        },
        ConcertAI: {
          description: "Kentucky",
          code: "KY",
        },
        XPT: {
          description: "Kentucky",
          code: "KY",
        },
        MDM: {
          description: "Kentucky",
          code: "KY",
        },
      },
      {
        "Canonical Value": {
          description: "Louisiana",
          code: "LA",
        },
        Onekey: {
          description: "Louisiana",
          code: "LA",
        },
        ConcertAI: {
          description: "Louisiana",
          code: "LA",
        },
        XPT: {
          description: "Louisiana",
          code: "LA",
        },
        MDM: {
          description: "Louisiana",
          code: "LA",
        },
      },
      {
        "Canonical Value": {
          description: "Maine",
          code: "ME",
        },
        Onekey: {
          description: "Maine",
          code: "ME",
        },
        ConcertAI: {
          description: "Maine",
          code: "ME",
        },
        XPT: {
          description: "Maine",
          code: "ME",
        },
        MDM: {
          description: "Maine",
          code: "ME",
        },
      },
      {
        "Canonical Value": {
          description: "Maryland",
          code: "MD",
        },
        Onekey: {
          description: "Montana",
          code: "MT",
        },
        ConcertAI: {
          description: "Montana",
          code: "MT",
        },
        XPT: {
          description: "Montana",
          code: "MT",
        },
        MDM: {
          description: "Montana",
          code: "MT",
        },
      },
      {
        "Canonical Value": {
          description: "Nebraska",
          code: "NE",
        },
        Onekey: {
          description: "Nebraska",
          code: "NE",
        },
        ConcertAI: {
          description: "Nebraska",
          code: "NE",
        },
        XPT: {
          description: "Nebraska",
          code: "NE",
        },
        MDM: {
          description: "Nebraska",
          code: "NE",
        },
      },
      {
        "Canonical Value": {
          description: "Nevada",
          code: "NV",
        },
        Onekey: {
          description: "Nevada",
          code: "NV",
        },
        ConcertAI: {
          description: "Nevada",
          code: "NV",
        },
        XPT: {
          description: "Nevada",
          code: "NV",
        },
        MDM: {
          description: "Nevada",
          code: "NV",
        },
      },
      {
        "Canonical Value": {
          description: "New Hampshire",
          code: "NH",
        },
        Onekey: {
          description: "New Hampshire",
          code: "NH",
        },
        ConcertAI: {
          description: "New Hampshire",
          code: "NH",
        },
        XPT: {
          description: "New Hampshire",
          code: "NH",
        },

        MDM: {
          description: "New Hampshire",
          code: "NH",
        },
      },
      {
        "Canonical Value": {
          description: "New Jersey",
          code: "NJ",
        },
        Onekey: {
          description: "New Jersey",
          code: "NJ",
        },
        ConcertAI: {
          description: "New Jersey",
          code: "NJ",
        },
        XPT: {
          description: "New Jersey",
          code: "NJ",
        },
        MDM: {
          description: "New Jersey",
          code: "NJ",
        },
      },
      {
        "Canonical Value": {
          description: "New Mexico",
          code: "NM",
        },
        Onekey: {
          description: "New Mexico",
          code: "NM",
        },
        ConcertAI: {
          description: "New Mexico",
          code: "NM",
        },
        XPT: {
          description: "New Mexico",
          code: "NM",
        },
        MDM: {
          description: "New Mexico",
          code: "NM",
        },
      },
      {
        "Canonical Value": {
          description: "New York",
          code: "NY",
        },
        Onekey: {
          description: "New York",
          code: "NY",
        },
        ConcertAI: {
          description: "New York",
          code: "NY",
        },
        XPT: {
          description: "New York",
          code: "NY",
        },
        MDM: {
          description: "New York",
          code: "NY",
        },
      },
      {
        "Canonical Value": {
          description: "North Carolina",
          code: "NC",
        },
        Onekey: {
          description: "North Carolina",
          code: "NC",
        },
        ConcertAI: {
          description: "North Carolina",
          code: "NC",
        },
        XPT: {
          description: "North Carolina",
          code: "NC",
        },
        MDM: {
          description: "North Carolina",
          code: "NC",
        },
      },
      {
        "Canonical Value": {
          description: "North Dakota",
          code: "ND",
        },
        Onekey: {
          description: "North Dakota",
          code: "ND",
        },
        ConcertAI: {
          description: "North Dakota",
          code: "ND",
        },
        XPT: {
          description: "North Dakota",
          code: "ND",
        },
        MDM: {
          description: "North Dakota",
          code: "ND",
        },
      },
      {
        "Canonical Value": {
          description: "Ohio",
          code: "OH",
        },
        Onekey: {
          description: "Ohio",
          code: "OH",
        },
        ConcertAI: {
          description: "Ohio",
          code: "OH",
        },
        XPT: {
          description: "Ohio",
          code: "OH",
        },
        MDM: {
          description: "Ohio",
          code: "OH",
        },
      },
      {
        "Canonical Value": {
          description: "Oklahoma",
          code: "OK",
        },
        Onekey: {
          description: "Oklahoma",
          code: "OK",
        },
        ConcertAI: {
          description: "Oklahoma",
          code: "OK",
        },
        XPT: {
          description: "Oklahoma",
          code: "OK",
        },
        MDM: {
          description: "Oklahoma",
          code: "OK",
        },
      },
      {
        "Canonical Value": {
          description: "Oregon",
          code: "OR",
        },
        Onekey: {
          description: "Oregon",
          code: "OR",
        },
        ConcertAI: {
          description: "Oregon",
          code: "OR",
        },
        XPT: {
          description: "Oregon",
          code: "OR",
        },
        MDM: {
          description: "Oregon",
          code: "OR",
        },
      },
      {
        "Canonical Value": {
          description: "Maryland",
          code: "MD",
        },
        Onekey: {
          description: "Maryland",
          code: "MD",
        },
        ConcertAI: {
          description: "Maryland",
          code: "MD",
        },
        XPT: {
          description: "Maryland",
          code: "MD",
        },
        MDM: {
          description: "Maryland",
          code: "MD",
        },
      },
      {
        "Canonical Value": {
          description: "Massachusetts",
          code: "MA",
        },
        Onekey: {
          description: "Massachusetts",
          code: "MA",
        },
        ConcertAI: {
          description: "Massachusetts",
          code: "MA",
        },
        XPT: {
          description: "Massachusetts",
          code: "MA",
        },
        MDM: {
          description: "Massachusetts",
          code: "MA",
        },
      },
      {
        "Canonical Value": {
          description: "Michigan",
          code: "MI",
        },
        Onekey: {
          description: "Michigan",
          code: "MI",
        },
        ConcertAI: {
          description: "Michigan",
          code: "MI",
        },
        XPT: {
          description: "Michigan",
          code: "MI",
        },
        MDM: {
          description: "Michigan",
          code: "MI",
        },
      },
      {
        "Canonical Value": {
          description: "Minnesota",
          code: "MN",
        },
        Onekey: {
          description: "Minnesota",
          code: "MN",
        },
        ConcertAI: {
          description: "Minnesota",
          code: "MN",
        },
        XPT: {
          description: "Minnesota",
          code: "MN",
        },
        MDM: {
          description: "Minnesota",
          code: "MN",
        },
      },
      {
        "Canonical Value": {
          description: "Mississippi",
          code: "MS",
        },
        Onekey: {
          description: "Mississippi",
          code: "MS",
        },
        ConcertAI: {
          description: "Mississippi",
          code: "MS",
        },
        XPT: {
          description: "Mississippi",
          code: "MS",
        },
        MDM: {
          description: "Mississippi",
          code: "MS",
        },
      },
      {
        "Canonical Value": {
          description: "Missouri",
          code: "MO",
        },
        Onekey: {
          description: "Missouri",
          code: "MO",
        },
        ConcertAI: {
          description: "Missouri",
          code: "MO",
        },
        XPT: {
          description: "Missouri",
          code: "MO",
        },
        MDM: {
          description: "Missouri",
          code: "MO",
        },
      },
      {
        "Canonical Value": {
          description: "Pennsylvania",
          code: "PA",
        },
        Onekey: {
          description: "Pennsylvania",
          code: "PA",
        },
        ConcertAI: {
          description: "Pennsylvania",
          code: "PA",
        },
        XPT: {
          description: "Pennsylvania",
          code: "PA",
        },
        MDM: {
          description: "Pennsylvania",
          code: "PA",
        },
      },
      {
        "Canonical Value": {
          description: "Rhode Island",
          code: "RI",
        },
        Onekey: {
          description: "Rhode Island",
          code: "RI",
        },
        ConcertAI: {
          description: "Rhode Island",
          code: "RI",
        },
        XPT: {
          description: "Rhode Island",
          code: "RI",
        },
        MDM: {
          description: "Rhode Island",
          code: "RI",
        },
      },
      {
        "Canonical Value": {
          description: "South Carolina",
          code: "SC",
        },
        Onekey: {
          description: "South Carolina",
          code: "SC",
        },
        ConcertAI: {
          description: "South Carolina",
          code: "SC",
        },
        XPT: {
          description: "South Carolina",
          code: "SC",
        },
        MDM: {
          description: "South Carolina",
          code: "SC",
        },
      },
      {
        "Canonical Value": {
          description: "South Dakota",
          code: "SD",
        },
        Onekey: {
          description: "South Dakota",
          code: "SD",
        },
        ConcertAI: {
          description: "South Dakota",
          code: "SD",
        },
        XPT: {
          description: "South Dakota",
          code: "SD",
        },
        MDM: {
          description: "South Dakota",
          code: "SD",
        },
      },
      {
        "Canonical Value": {
          description: "Tennessee",
          code: "TN",
        },
        Onekey: {
          description: "Tennessee",
          code: "TN",
        },
        ConcertAI: {
          description: "Tennessee",
          code: "TN",
        },
        XPT: {
          description: "Tennessee",
          code: "TN",
        },
        MDM: {
          description: "Tennessee",
          code: "TN",
        },
      },
      {
        "Canonical Value": {
          description: "Texas",
          code: "TX",
        },
        Onekey: {
          description: "Texas",
          code: "TX",
        },
        ConcertAI: {
          description: "Texas",
          code: "TX",
        },
        XPT: {
          description: "Texas",
          code: "TX",
        },
        MDM: {
          description: "Texas",
          code: "TX",
        },
      },
      {
        "Canonical Value": {
          description: "Utah",
          code: "UT",
        },
        Onekey: {
          description: "Utah",
          code: "UT",
        },
        ConcertAI: {
          description: "Utah",
          code: "UT",
        },
        XPT: {
          description: "Utah",
          code: "UT",
        },
        MDM: {
          description: "Utah",
          code: "UT",
        },
      },
      {
        "Canonical Value": {
          description: "Vermont",
          code: "VT",
        },
        Onekey: {
          description: "Vermont",
          code: "VT",
        },
        ConcertAI: {
          description: "Vermont",
          code: "VT",
        },
        XPT: {
          description: "Vermont",
          code: "VT",
        },
        MDM: {
          description: "Vermont",
          code: "VT",
        },
      },
      {
        "Canonical Value": {
          description: "Virginia",
          code: "VA",
        },
        Onekey: {
          description: "Virginia",
          code: "VA",
        },
        ConcertAI: {
          description: "Virginia",
          code: "VA",
        },
        XPT: {
          description: "Virginia",
          code: "VA",
        },
        MDM: {
          description: "Virginia",
          code: "VA",
        },
      },
      {
        "Canonical Value": {
          description: "Washington",
          code: "WA",
        },
        Onekey: {
          description: "Washington",
          code: "WA",
        },
        ConcertAI: {
          description: "Washington",
          code: "WA",
        },
        XPT: {
          description: "Washington",
          code: "WA",
        },
        MDM: {
          description: "Washington",
          code: "WA",
        },
      },
      {
        "Canonical Value": {
          description: "West Virginia",
          code: "WV",
        },
        Onekey: {
          description: "West Virginia",
          code: "WV",
        },
        ConcertAI: {
          description: "West Virginia",
          code: "WV",
        },
        XPT: {
          description: "West Virginia",
          code: "WV",
        },
        MDM: {
          description: "West Virginia",
          code: "WV",
        },
      },
      {
        "Canonical Value": {
          description: "Wisconsin",
          code: "WI",
        },
        Onekey: {
          description: "Wisconsin",
          code: "WI",
        },
        ConcertAI: {
          description: "Wisconsin",
          code: "WI",
        },
        XPT: {
          description: "Wisconsin",
          code: "WI",
        },
        MDM: {
          description: "Wisconsin",
          code: "WI",
        },
      },
      {
        "Canonical Value": {
          description: "Wyoming",
          code: "WY",
        },
        Onekey: {
          description: "Wyoming",
          code: "WY",
        },
        ConcertAI: {
          description: "Wyoming",
          code: "WY",
        },
        XPT: {
          description: "Wyoming",
          code: "WY",
        },
        MDM: {
          description: "Wyoming",
          code: "WY",
        },
      },
    ],
  },
]

export const DRUG_MODEL_SEED = [
  { name: "drug_id", displayName: "drug_id", description: "Represents the unique identifier for the drug", dataType: "int", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "created_time", displayName: "created_time", description: "Represents the Created Time", dataType: "Date", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "updated_time", displayName: "updated_time", description: "Represents the Updated Time", dataType: "Date", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "drug_name", displayName: "drug_name", description: "Represents the full drug name", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "ingredient", displayName: "ingredient", description: "Represents the active ingredient of the drug", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "strength", displayName: "strength", description: "Represents the drug strength", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "brand_name", displayName: "brand_name", description: "Represents the brand name of the drug", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "source", displayName: "source", description: "Represents the data source(s) for the drug", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "ndc", displayName: "ndc", description: "Represents the National Drug Code", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "pkg", displayName: "pkg", description: "Represents the packaging information", dataType: "String", required: false, hidden: false, searchable: false, lookupType: "Countries" },
  { name: "manufacturer", displayName: "manufacturer", description: "Represents the drug manufacturer", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "brand_id", displayName: "brand_id", description: "Represents the Brand ID", dataType: "int", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "is_deleted", displayName: "is_deleted", description: "Indicates if the drug record is deleted", dataType: "Boolean", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "form", displayName: "form", description: "Represents the drug form (e.g., tablet, capsule)", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "client_drug_flag", displayName: "client_drug_flag", description: "Indicates if the drug is client-specific", dataType: "Boolean", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "brand_type", displayName: "brand_type", description: "Represents the type of brand (e.g., Branded, Generic)", dataType: "String", required: false, hidden: false, searchable: true, lookupType: "Countries" },
  { name: "status", displayName: "status", description: "Represents the status of the drug record", dataType: "String", required: true, hidden: false, searchable: true, lookupType: "Countries" },
];

export const DRUG_VALIDATION_SEED = [
  { name: "NDC", validationLevel: "error", lastModifiedDate: "31/07/2025", type: "exists", active: true, rule: "", description: "NDC is required and cannot be empty." },
  { name: "Brand", validationLevel: "error", lastModifiedDate: "31/07/2025", type: "exist", active: true, rule: "", description: "Brand is required and cannot be empty." },
  { name: "Market", validationLevel: "error", lastModifiedDate: "31/07/2025", type: "exists", active: true, rule: "", description: "Market is required and cannot be empty." },
  { name: "DrugName", validationLevel: "warning", lastModifiedDate: "31/07/2025", type: "exists", active: true, rule: "", description: "Drug Name is required" },
  { name: "formTlc3", validationLevel: "warning", lastModifiedDate: "31/07/2025", type: "exists", active: true, rule: "", description: "FormTcl3 is required." },
  { name: "dosage factor", validationLevel: "warning", lastModifiedDate: "31/07/2025", type: "exists", active: true, rule: "", description: "Drug Dosage factor is required" },
];

export const DRUG_CLEANSER_SEED = [
  { displayName: "Drug Name Cleanser", attribute: "Drug Name", cleanserType: "Custom cleanser", cleanser: "product name cleanser", url: "https://mdm.data-aces.com/pharma/v1/cleanser/drugname", lastModifiedDate: "18/07/2025", active: true },
  { displayName: "Drug FormTcl3 Cleanser", attribute: "formTcl3", cleanserType: "Custom cleanser", cleanser: "Drug FormTlc3 cleanser", url: "https://mdm.data-aces.com/pharma/v1/cleanser/formTcl3", lastModifiedDate: "31/07/2025", active: true },
];

export const DRUG_RDM_SEED = [
  { 
    name: "Drug Form Lookup", 
    startdate: "2023-01-01", 
    enddate: "2023-12-31", 
    sourcevalues: 20, 
    unmappedvalues: 0,
    tableData: [
      {
        "Canonical Value": { "description": "Tablet", "code": "Tablet" },
        "NPA": { "description": "Tab", "code": "Tab" },
        "XPT": { "description": "Tab", "code": "Tab" }
      },
      {
        "Canonical Value": { "description": "Capsule", "code": "Capsule" },
        "NPA": { "description": "Cap", "code": "Cap" },
        "XPT": { "description": "Capsule", "code": "Capsule" }
      },
      {
        "Canonical Value": { "description": "Injection", "code": "Injection" },
        "NPA": { "description": "Inj", "code": "Inj" },
        "XPT": { "description": "Injection", "code": "Injection" }
      },
      {
        "Canonical Value": { "description": "Syrup", "code": "Syrup" },
        "NPA": { "description": "Syr", "code": "Syr" },
        "XPT": { "description": "Syrup", "code": "Syrup" }
      },
      {
        "Canonical Value": { "description": "Solution", "code": "Solution" },
        "NPA": { "description": "Soln", "code": "Soln" },
        "XPT": { "description": "Solution", "code": "Solution" }
      },
      {
        "Canonical Value": { "description": "Cream", "code": "Cream" },
        "NPA": { "description": "Crm", "code": "Crm" },
        "XPT": { "description": "Cream", "code": "Cream" }
      },
      {
        "Canonical Value": { "description": "Ointment", "code": "Ointment" },
        "NPA": { "description": "Oint", "code": "Oint" },
        "XPT": { "description": "Ointment", "code": "Ointment" }
      },
      {
        "Canonical Value": { "description": "Gel", "code": "Gel" },
        "NPA": { "description": "Gel", "code": "Gel" },
        "XPT": { "description": "Gel", "code": "Gel" }
      },
      {
        "Canonical Value": { "description": "Drops", "code": "Drops" },
        "NPA": { "description": "Drp", "code": "Drp" },
        "XPT": { "description": "Drops", "code": "Drops" }
      },
      {
        "Canonical Value": { "description": "Powder", "code": "Powder" },
        "NPA": { "description": "Pwd", "code": "Pwd" },
        "XPT": { "description": "Powder", "code": "Powder" }
      },
      {
        "Canonical Value": { "description": "Spray", "code": "Spray" },
        "NPA": { "description": "Spr", "code": "Spr" },
        "XPT": { "description": "Spray", "code": "Spray" }
      },
      {
        "Canonical Value": { "description": "Suspension", "code": "Suspension" },
        "NPA": { "description": "Susp", "code": "Susp" },
        "XPT": { "description": "Suspension", "code": "Suspension" }
      },
      {
        "Canonical Value": { "description": "Lotion", "code": "Lotion" },
        "NPA": { "description": "Lot", "code": "Lot" },
        "XPT": { "description": "Lotion", "code": "Lotion" }
      },
      {
        "Canonical Value": { "description": "Patch", "code": "Patch" },
        "NPA": { "description": "Pch", "code": "Pch" },
        "XPT": { "description": "Patch", "code": "Patch" }
      },
      {
        "Canonical Value": { "description": "Inhaler", "code": "Inhaler" },
        "NPA": { "description": "Inh", "code": "Inh" },
        "XPT": { "description": "Inhaler", "code": "Inhaler" }
      },
      {
        "Canonical Value": { "description": "Suppository", "code": "Suppository" },
        "NPA": { "description": "Supp", "code": "Supp" },
        "XPT": { "description": "Suppository", "code": "Suppository" }
      },
      {
        "Canonical Value": { "description": "Elixir", "code": "Elixir" },
        "NPA": { "description": "Elx", "code": "Elx" },
        "XPT": { "description": "Elixir", "code": "Elixir" }
      },
      {
        "Canonical Value": { "description": "Granules", "code": "Granules" },
        "NPA": { "description": "Grn", "code": "Grn" },
        "XPT": { "description": "Granules", "code": "Granules" }
      },
      {
        "Canonical Value": { "description": "Emulsion", "code": "Emulsion" },
        "NPA": { "description": "Emul", "code": "Emul" },
        "XPT": { "description": "Emulsion", "code": "Emulsion" }
      },
      {
        "Canonical Value": { "description": "Mouthwash", "code": "Mouthwash" },
        "NPA": { "description": "Mwash", "code": "Mwash" },
        "XPT": { "description": "Mouthwash", "code": "Mouthwash" }
      }
    ]
  }
];

